const genericStrings = {
    stepCount: "Étape {current} sur {total}",
    dragHint: "Glisser pour réordonner",
    shiftHours: "Horaires de service",
    quantity: "Quantité",
    rate: "Taux",
    printState: "État d'impression",
    showAccount: "Voir le compte",
    closed: "Fermé",
    applyToWeek: "Appliquer à toute la semaine",
    addSlot: "Ajouter une plage",
    copy: "Copier",
    url: "URL",
    mode: "Mode",
    bulk: "En lot",
    style: "Style",
    customName: "Nom personnalisé",
    customTableName: "Nom de table personnalisé",
    prefix: "Préfixe",
    startTable: "Table de début",
    endTable: "Table de fin",
    single: "Unique",
    unlimited: "Illimité",
    custom: "Personnalisé",
    dayRequired: "Le jour est requis.",
    startHourRequired: "L'heure de début est requise.",
    endHourRequired: "L'heure de fin est requise.",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    displayOrder: "Ordre",
    add: "Ajouter",
    group: "Groupe",
    image: "Image",
    visibility: "Visibilité",
    searchByName: "Rechercher par nom",
    searchByGroup: "Rechercher par groupe",
    email: "Email",
    notAvailable: "N/A",
    noResult: "Aucun résultat.",
    searchResultsFor: "{count} résultat pour « {query} » | {count} résultats pour « {query} »",
    noResultHint: "Essayez avec un autre terme.",

    voucher: "Vouchers",

    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    notDefined: "Non défini",
    allSaved: "Tout est enregistré",
    unsavedChanges: "1 modification | {count} modifications",
    copied: "Copié",
    remove: "Retirer",
    apply: "Appliquer",
    invalidUrl: "Saisissez une URL valide commençant par https://",
    addImage: "Importer une image",
    addFile: "Importer un fichier",
    fileTypeError: "Ce type de fichier n'est pas accepté",
    openingHours: "Horaires d'ouvertures",
    appRefund: "Remboursement",
    appHideCashboxButton: "Masquer le bouton du tiroir-caisse",
    appNoPinUserLogin: "Connexion utilisateur sans code PIN",
    serviceMode: "Commande",
    duplicateProductWithGroup: "Inclure les produits du groupe dans la duplication ?",
    normal: "Normal",
    existingClient: "Client existant",
    newClient: "Nouveau client",
    next: "Suivant",
    previous: "Précédent",
    assignClient: "Assigner à un client",
    searchClient: "Sélectionner un client",
    onSite: "Sur place",
    cancelOrderedProduct: "Annuler les produits commandés",
    showOnlyOwnAccounts: "Voir uniquement ses comptes",
    cleanOption: "Supprimer les sous-options",
    sendInvoice: "Envoyer une facture",
    customInvoiceNumber: "Numéro de facture",
    vatTicket: "Ticket TVA",
    vatTicketSend: "Envoyer par mail",
    vatTicketDownloadHint: "Le ticket TVA sera téléchargé au format PDF.",
    submit: "Envoyer",
    showProduct: "Aller au produit",
    showGroupsProduct: "Voir les produits du groupe",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    org_id: "ID de l'organisation",
    edit: "Modifier",
    hide: "Masquer",
    preview: "Aperçu",
    moveUp: "Monter",
    moveDown: "Descendre",
    duplicate: "Dupliquer",
    show: "Afficher",
    save: "Enregistrer",
    cancel: "Annuler",
    back: "Retour",
    create: "Créer",
    digitalMenu: "Menu digital",
    viewApiDocs: "Documentation API",
    deliveryArea: "Zones de livraison",
    search: "Rechercher",
    clearFilter: "Effacer le filtre",
    download: "Télécharger",
    downloadX: "Télécharger X",
    downloadZ: "Télécharger Z",
    confirmLeave: "Vous avez des modifications non enregistrées.<br/>Voulez-vous quitter la page ?",
    from: "De",
    to: "À",
    total: "Total",
    fileSizeError: "La taille du fichier est trop grande, choisissez un fichier plus petit que {size} MB",
    fileAttached: "{name} — sera envoyé à la sauvegarde",
    paid: "Payé",
    vat: "TVA",
    globalSearch: "Recherche",
    user: "Utilisateur",
    comment: "Commentaire",
    price: "Prix",
    accountId: "ID de compte",
    name: "Nom",
    id: "Id",
    actions: "Actions",
    refresh: "Rafraîchir",
    account: "Compte",
    accountInfo: "Info du compte",
    status: "Statut",
    openedAt: "Ouvert à",
    closedAt: "Fermé à",
    open: "Ouvrir",
    close: "Fermer",
    tableNumber: "Table",
    noName: "Sans nom",
    delete: "Supprimer",
    takeaway: "À emporter",
    deleteConfirm: "Êtes-vous sûr de vouloir supprimer ceci ?<br> Cette action est irréversible !",
    removeFromSelection: "Retirer de la sélection",
    date: "Date",
    filter: "Filtrer",
    matchContains: "Contient",
    matchNotContains: "Ne contient pas",
    matchStartsWith: "Commence par",
    matchEndsWith: "Se termine par",
    matchEquals: "Égal à",
    ipAddress: "Adresse IP",
    color: "Couleur",
    yes: "Oui",
    no: "Non",
    all: "Tous",
    changePayType: (ctx) => `Changer le type de paiement de ${ctx.named('of')} de ${ctx.named('from')} à ${ctx.named('to')} ? `,
    tables: "Tables",
    delivery: "Livraison",
    shift: "Services",
    openAccounts: "Comptes ouverts",
    openTicketsCurrentShift: "Comptes du service en cours",
    lastShift: "Dernier service",
    dailySales: "Ventes quotidiennes",
    rushHours: "Heures de pointe",
    dashboardIntervalChoice: 'Intervalle sélectionné',
    dashboardIntervalCurrentShift: 'Service actuel',
    dashboardIntervalLastShift: 'Dernier service',
    dashboardIntervalYesterday: 'Hier',
    dashboardIntervalThisWeek: 'Cette semaine',
    dashboardIntervalLastWeek: 'La semaine dernière',
    dashboardIntervalThisMonth: 'Ce mois-ci',
    dashboardIntervalLastMonth: 'Le mois dernier',
    dashboardIntervalLast7Days: 'Les 7 derniers jours',
    dashboardIntervalLast30Days: 'Les 30 derniers jours',
    dashboardIntervalLast90Days: 'Les 90 derniers jours',
    dashboardIntervalCustom: 'Personnalisé',
    dateTimePlaceholder: 'jj/mm/aaaa hh:mm',
    datePlaceholder: 'jj/mm/aaaa',
    select: "Sélectionner",
    bulkEdit: "Edition multiple",
    bulkEditProducts: "Modifier {count} produit | Modifier {count} produits",
    bulkEditGroups: "Modifier {count} groupe | Modifier {count} groupes",
    clients: 'Clients',
    superUserShort: 'SU',
    mail: 'Mail',
    phone: 'Phone',
    address: 'Adresse',
    street: 'Rue',
    city: 'Ville',
    shiftUser: "Service Travailleur",
    noDataFound: "Aucune donnée trouvée",
    itemsSelected: "{count} sélectionnés",
    loadingData: "Chargement des données, veuillez patienter.",
    pickup: "Ramassage",
    promo: "Promotion",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
    login: "Se connecter",
    product: "Produits",
    productGroup: "Groupes de produits",
    table: "Tables",
    printer: "Imprimantes",
    client: "Client",
    invoice: "Factures",
    dashboard: "Tableau de bord",
    dashboardGroups: "Tableau de bord groupes",
    dashboardLimitedInterval: "Intervalles limités",
    accounts: "Comptes",
    order: "Commandes",
    stock: "Stocks",
    error: "Erreur",
    bankTransfer: "Virement bancaire",
    offered: "Offert",
    disableCash: "Désactiver l'argent liquide",
    disableCard: "Désactiver la carte",
    kiosk: "Kiosque",
    payment: "Paiement",
    customerCredit: "Crédit client",
    paymentForced: "Paiement forcé",
    paymentTransaction: "Détails des transactions",
    analytics: "Analyses",
    admin: "Administrateur",
    paymentMethod: "Moyen de paiement",
    transactionType: "Type de transaction",
    amountPaid: "Total payé",
    amountReturned: "Total rendu",
    tip: "Pourboir",
    rounding: "Arrondi",
    none: "Aucun",
    doNotChange: "Ne pas modifier",
    detachParent: "Détacher du parent",
    cash: "Cash",
    card: "Carte",
    free: "Gratuit",
    mixed: "Mixte",
    transfer: "Virement",
    forceCloseShift: "Clôture forcée du shift",
    general: "Général App",
    appSearchAccounts: "Recherche de comptes",
    appCorrectPayment: "Payments correct",
    disableEatIn: "Désactiver sur place",
    disableTakeaway: "Désactiver à emporter",
    emptyStateTitle: "Aucune donnée",
    emptyStateText: "Démarrez un service pour afficher votre tableau de bord.",
    emptyStateBtn: "Démarrer un service",
    newVersionReload: "Une nouvelle version de l'admin est disponible. Rechargez la page.",
    serviceDetails: "Details du service",
    hours: "Heures",
    cashRegister: "Caisse",
    start: "Début",
    end: "Fin",
    startDate: "Date de début",
    endDate: "Date de fin",
    dateRange: "Plage de dates",
    clear: "Effacer",
    send: "Envoyée",
    created: "Créée",
    canceled: "Annulée",
    invoicing: "Facturation",
    invoice_send: "Envoyer",
    invoice_get: "Consultation",
    invoice_all: "Accès complet",
    invoice_paid: "Marquer/consulter",
    orgType: "Type de l'organisation",
    reorganize: "Réorganiser l'ordre",
    done: "Sauvegarder",
    tabletMode: "Vue tablette",
    exitTabletMode: "Quitter la vue tablette",
    subOption: "Sous-options",
    barcode: "Code-barres",
    advanced: "Paramètres avancés",
    optionProduct: "Options du produit",
    confirmAction: "Etes-vous sûr de vouloir effectuer cette action ?",
    orderAtTable: "COMMANDER A TABLE",
    generateCodeQr: "Générer un code QR",
    dynamicPrice: "Prix dynamique",
    summaryRev: "Résumé des modifications",
    reset: "Réinitialiser",
};

const navBarStrings = {
    products: "Produits",
    catalog: "Catalogue",
    groups: "Groupes",
    productOptions: "Listes d'options",
    home: "Accueil",
    users: "Utilisateurs",
    tables: "Tables",
    my_account: "Mon compte",
    settings: "Paramètres",
    dashboard: "Dashboard",
    analytics: "Analyses",
    account: "Compte",
    acitivity: "Activité",
    order_history: "Commandes",
    account_history: "Comptes",
    shifts: "Services",
    shift: "Service Z",
    payments: "Paiements",
    log: "Journal",
    logout: "Déconnexion",
    printers: "Imprimantes",
    stock: "Stock",
    image: "Images",
    pickup: "Pickup",
    kitchen: "Message",
    clients: "Clients",
    invoice: "Factures",
    promo: "Promotions",
    extIntegration: "Intégrations",
    createOrg: "Créer une orga",
    superUser: "Super User",
    superUsers: "Super Users",
    dashboardSU: "Dashboard SU",
    menu: "Menu",
    importCSV: "Import menu",
    deliveryAreas: "Livraison",
    icons: "Icônes",
    vouchers: "Vouchers",
    searchOrg: "Rechercher une organisation",
    noOrgFound: "Aucune organisation"
};

const toastStrings = {
    vatTicketSent: "Ticket TVA envoyé",
    groupNameTooShort: "Le nom doit contenir au moins 3 caractères",
    successSave: "Enregistrement réussi",
    errorSave: "Erreur d'enregistrement",
    successEdit: "Modification réussie",
    errorEdit: "Erreur de modification",
    createSuccess: "Création réussie",
    createError: "Erreur de création",
    deleteSuccess: "Suppression réussie",
    deleteError: "Erreur de suppression",
    duplicateSuccess: "Duplication réussie",
    duplicateError: "Erreur de duplication",
    copySuccess: "Lien copié",
    deleteGroupNotAllowed: "Impossible de supprimer un groupe non vide",
    errorNotSelected: "Veuillez selectionner au moins un item",
    cannotDeleteInvoicedAccount: "Impossible de supprimer un compte déjà facturé.",
    cannotEdit: "item hérité : certains champs sont non modifiables.",
    downloadError: "Le téléchargement a échoué, veuillez réessayer."
};

const loginPageStrings = {
    welcome_back: "Bon retour",
    login_page_subtitle: "Votre compagnon de restaurant parfait toujours là quand vous en avez besoin",
    login_page_form_title: "Connectez-vous",
    login_page_form_subtitle: "Entrez vos identifiants",
    login_button: "Connexion"
};

const integrationStrings = {
    addInt: "Ajouter une intégration",
    ipAddress: "Adresse",
    user: "Utilisateur",
    protocol: "Protocole",
    localPrint: 'Impression local',
    webtoolUrl: "URL Webtool",
    authKey: "Clé d'authentification",
    noIntegration: "Aucune intégration",
    noIntegrationHint: "Ajoutez une intégration pour commencer.",
    serialNumber: "Numéro de série",
    editInt: "Modifier l'intégration"
}

const deviceStrings = {
    emptyTable: "Aucun appareil trouvé.",
    serialNumber: "Numéro de série",
    model: "Modèle",
    brand: "Marque",
    osVersion: "Version OS",
    appVersion: "Version app",
    lastUsedUser: "Dernier utilisateur",
    boundUser: "Utilisateur lié",
    device: "Appareils",
    deleteAll: "Supprimer tous les appareils",
}

const dashboardStrings = {
    morePeriods: "Plus",
    organisations: "Organisations",
    devices: "Appareils",
    openShifts: "Services ouverts",
    orgName: "Nom de l'organisation",
    searchOrganisation: "Rechercher une organisation...",
    searchShift: "Rechercher un service, une organisation...",
    noOrganisation: "Aucune organisation",
    noOpenShift: "Aucun service ouvert",
    switchToOrg: "Basculer vers cette organisation",
    openShiftDetail: "Voir le service",
    lastDays: "{days} derniers jours",
    yoursInfos: "Votre établissement",
    empty: "Aucune table n'est occupée",
    shiftTitle: "Table ouverte",
    openTableText: "Table ouverte",
    takeawayText: "À emporter ouvert",
    noshiftOpen: "Aucun service ouvert",
    takeawayTitle: "À emporter",
    currentShift: "Service en cours",
    latestShift: "Dernier service",
    lastShift: "Dernier service",
    accountsTotal: "Total des comptes",
    accountsTooltip: "Nombre de comptes ouverts appartenant aux shifts sélectionnés (Ou au moins 1 article du compte a été payé)",
    remainingUnpaid: "Reste à payer",
    remainingUnpaidTooltip: "Montant total restant à payer pour les comptes ouverts appartenant ou non aux shifts sélectionnés",
    salesPaid: "Ventes payées",
    salesPaidTooltip: "Montant total payé pour les comptes ouverts et fermés appartenant aux shifts sélectionnés",
    averageBasket: "Panier moyen",
    orgId: "ID org",
    unnamedOrg: "Organisation sans nom",
};

const productGroupsDashboardStrings = {
    title: "Ventes par groupe de produits",
    totalRevenue: "Chiffre d'affaires",
    totalRevenueTooltip: "Chiffre d'affaires total TTC de tous les groupes affichés",
    quantitySold: "Quantité vendue",
    accountCount: "Comptes",
    accountCountTooltip: "Nombre de comptes (tickets) distincts",
    averageBasket: "Panier moyen",
    subGroups: "Sous-groupes",
    topProducts: "Top produits",
    rushHours: "Heures de pointe",
    revenueInclVat: "Ventes totales",
    vatByRate: "TVA par taux",
    vatRate: "Taux",
    vatExcl: "HTVA",
    vatAmount: "TVA",
    vatIncl: "TTC",
    salesByChannel: "Ventes par canal",
    paymentCash: "Espèces",
    paymentCard: "Carte",
    paymentTransfer: "Virement",
    discountTotal: "Remises",
    averagePrice: "Prix moyen",
    details: "Détails",
    empty: "Aucune donnée à afficher pour cette période",
    forbidden: "Vous n'avez pas accès à ce tableau de bord",
};

const userPageStrings = {
    createPartialError: "L'utilisateur a été créé, mais certains réglages n'ont pas pu être enregistrés : {error}. Modifiez-le pour les compléter.",
    kdsCallMode: "Mode écran d'appel KDS",
    kdsCallModeTooltip: "Lorsqu'activé, chaque commande apparaît dans un seul état sur l'écran cuisine. Une commande passe en cours dès qu'un article est en préparation, et en prêt uniquement lorsque tous les articles sont terminés.",
    userSubscribedProductGroupIds: "Groupe de produits",
    userSubscribedProductGroupIdsTooltip: "L’utilisateur ne pourra voir que les groupes sélectionnés lorsqu’il sera connecté.",
    userSubscribedZoneId: "Zones de tables",
    userSubscribedZoneIdTooltip: "L’utilisateur ne pourra voir que les zones sélectionnées lorsqu’il sera connecté.",

    vwMultiMerchantId: "ID multi merchant VW",
    vwMultiMerchantIdTooltip: "Identifie le compte marchand de l’utilisateur dans la configuration multi-marchands de Viva Wallet.",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    type: "Type d'utilisateur",
    pincode: "Code PIN",
    vwTerminalIp: "IP du terminal VW",
    vwTerminalId: "ID du Terminal VW (cloud)",
    userPrinter: "Imprimante de l'utilisateur",
    selectAbilities: "Sélectionner les capacités",
    appMode: "Mode d'affichage",
    pincodeTooltip: "Le code PIN de la caisse est utilisé pour deverrouiller la caisse enregistreuse lorsque le verrouillage par code PIN est activé. Il sera aussi utilisé enregistrer les actions de l'utilisateur sur la caisse principale",
    userPrinterTooltip: "L'imprimante qui sera utilisée pour cet utilisateur. Cela remplacera l'imprimante principale si elle est définie et permettra d'imprimer les tickets de TVA/récapitulatifs sur cette imprimante",
    fullAccess: "Accès complet",
    userIntegrations: "Intégrations",
    userIntegrationsTooltip: "Les intégrations (monnayeur, terminal de paiement…) liées à cet utilisateur. Cocher une intégration d'un autre utilisateur la lui retire, en décocher une la supprime à l'enregistrement.",
    integrationsDeleteWarning: "Attention, ces intégrations seront supprimées à l'enregistrement : {list}",
    kdsSubscribedProductGroupIds: "Groupes de produits KDS",
    kdsSubscribedProductGroupIdsTooltip: "Attribuez les groupes de produits qui seront expédiés à cet utilisateur du KDS. Si aucun groupe n’est attribué, l’utilisateur recevra toutes les commandes.",
    addUser: "Ajouter un utilisateur",
    niss: "NISS",
    blackboxTester: "Training",
    cannotDeleteAdmin: "Cet utilisateur ne peut pas être supprimé",
    duplicate: "Dupliquer",
    cannotDuplicateUser: "Cet utilisateur ne peut pas être dupliqué",
    duplicateFrom: "Copie de {username}",
    duplicateMissingFields: "Veuillez remplir le nom d'utilisateur, le mot de passe et le code PIN",
    passwordGenerationRequired: "Veuillez générer un mot de passe",
    passwordGeneratePlaceholder: "Aucun mot de passe",
    apiDocsPasswordRules: "Avec l'accès à la documentation API, le mot de passe doit contenir au moins {length} caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial",
    apiDocsPasswordRegenerate: "L'accès à la documentation API vient d'être ajouté : régénérez le mot de passe pour en obtenir un de {length} caractères",
    adminPasswordRules: "Le mot de passe admin doit contenir au moins {length} caractères, dont une majuscule, une minuscule et un caractère spécial",
    linkDevice: "Lier un appareil",
    pairingCode: "Code d'association",
    pairingCodePlaceholder: "000000",
    pairingCodeTooltip: "Le code à 6 chiffres affiché sur l'appareil à lier. Il reste valable 10 minutes tant que l'appareil reste sur l'écran d'association.",
    linkDeviceWarning: "L'appareil se connectera avec ce compte sans saisir de mot de passe. Un appareil déjà lié à ce compte devra se reconnecter avec son mot de passe.",
    linkDeviceWaiting: "En attente de la connexion de l'appareil, cela peut prendre jusqu'à 60 secondes…",
    linkDeviceSuccess: "Appareil lié avec succès",
    linkDeviceError: "L'appareil n'a pas pu être lié",
    pairingCodeOptional: "Facultatif",
    pairingCodeEditTooltip: "Saisissez le code à 6 chiffres affiché sur l'appareil pour qu'il se connecte directement avec ce compte à l'enregistrement. Un appareil déjà lié à ce compte devra se reconnecter avec son mot de passe.",
    pairingCodeInvalid: "Le code d'association doit contenir 6 chiffres",
    createLinkDeviceError: "L'utilisateur a été créé, mais l'appareil n'a pas pu être lié : {error}. Modifiez-le pour saisir à nouveau le code.",
    scanPairingCode: "Scanner le QR code",
    scanPairingCodeInvalid: "Ce QR code ne contient pas de code d'association",
    cameraUnavailable: "Impossible d'accéder à la caméra. Autorisez-la dans les réglages du navigateur.",
    cameraRequiresHttps: "La caméra n'est accessible que sur une page en HTTPS.",
    linkDeviceUser: "Utilisateur",
    linkDeviceUserPlaceholder: "Choisir un utilisateur"
};

const imagePageStrings = {
    name: "Médias",
    addImage: "Ajouter un média",
    textEnter: "Entrer l'url :",
    textUpload: "Glissez-déposez vos médias ici ou cliquez pour ajouter",
    fileTooLarge: "Le fichier dépasse la limite de 2 Mo",
    limit: "Le fichier dépasse la taille limite de 2MB",
    allTypes: "Tous les types",
    imagesOnly: "Images",
    videosOnly: "Vidéos",
    addSuccess: "{count} média(s) ajouté(s)",
    addError: "{count} média(s) n'ont pas pu être ajouté(s)",
    uploadLimits: "Images jusqu'à {image} Mo, vidéos jusqu'à {video} Mo",
    noMedia: "Aucun média",
    noMediaHint: "Ajoutez une image ou une vidéo pour commencer.",
    type: "Type",
    video: "Vidéo"
}

const superUserPageStrings = {
    validation: {
        username: "Le nom d'utilisateur est requis",
        email: "L'email est requis"
    },
    createTitle: "Créer un Super User",
    editTitle: "Modifier un Super User",
    addSuperUser: "Ajouter un super utilisateur",
    username: "Nom d'utilisateur",
    usernameHint: "Doit commencer par su_",
    email: "Email",
    phoneNumber: "Numéro de téléphone",
    partnerSource: "Source partenaire",
    abilities: "Capacités",
    abilityCreateOrg: "Créer une organisation",
    abilityCreateUser: "Créer un Super User",
    abilityViewApiDocs: "Accès à la documentation API",
    regenerate: "Régénérer",
    regeneratePassword: "Régénérer le mot de passe",
    regeneratePasswordConfirm: "Régénérer le mot de passe de {username} ?<br>Il sera envoyé à {email}.",
    deleteConfirm: "Voulez-vous vraiment supprimer {username} ?<br> Cette action est irréversible."
}

const iconsPageStrings = {
    name: "Icônes",
    addIcon: "Ajouter une icône",
    internalName: "Nom interne",
    nameFR: "Nom (FR)",
    nameNL: "Nom (NL)",
    nameEN: "Nom (EN)",
    searchPlaceholder: "Rechercher une icône",
    empty: "Aucune icône trouvée",
    preview: "Aperçu",
    category: "Catégorie",
    url: "URL",
    allCategories: "Toutes les catégories",
    group: "Groupe",
    ingredient: "Ingrédient",
    textUpload: "Glissez-déposez vos icônes ici ou cliquez pour ajouter",
    addSuccess: "{count} icône(s) ajoutée(s)",
    addError: "{count} icône(s) n'ont pas pu être ajoutée(s)",
    categoryValues: {
        GROUP: "Groupe",
        ALLERGEN: "Allergène"
    },
    validation: {
        name: "Le nom est requis",
        url: "L'URL est requise",
        file: "L'image est requise",
        category: "La catégorie est requise",
        duplicateName: "Ce nom est utilisé plusieurs fois"
    }
}

const productGroupPageStrings = {
    deleteBlocked: "Suppression impossible : ces groupes contiennent encore des produits ou des sous-groupes non sélectionnés : {groups}",
    addSubGroup: "Ajouter un sous-groupe",
    productGroups: "Groupes de produits",
    addGroup: "Ajouter un groupe",
    expandAll: "Tout déplier",
    collapseAll: "Tout replier",
    searchGroup: "Rechercher un groupe",
    noParent: "Aucun (groupe seul)",
    manageSubGroups: "Gérer les sous-groupes",
    selectAll: "Tout sélectionner",
    deselectAll: "Tout désélectionner",
    optionOrderTooltip: "Ordre de ce groupe lorsqu'il est utilisé comme option pour un produit",
    vatIn: "TVA entrée",
    vatOut: "TVA sortie",
    printerIp: "Adresse IP de l'imprimante",
    name: "Nom",
    userHidden: "Caché sur app?",
    webHidden: "Caché sur site web?",
    isHidden: "Caché dans l'application",
    isNotHidden: "Visible dans l'application",
    KitchenPrintEnabled: "Imprimer?",
    groupOrder: "Ordre du groupe",
    loadingResultTable: "Chargement des données. Veuillez patienter.",
    color: "Couleurs",
    vatTooltip: "Une TVA qui sera suggérée lorsque ce groupe sera attribué à un produit. Changer ceci ne modifiera pas les TVA des produits de ce groupe",
    orderTooltip: "Ordre du groupe dans la liste, cela sera utilisé pour trier les groupes par ordre croissant",
    kitchenPrintEnabledTooltip: "Activer/Désactiver l'impression des commandes sur l'imprimante assignée pour les produits de ce groupe",
    userHiddenTooltip: "Masquer ce groupe de l'interface utilisateur empêchant les commandes directes des produits de ce groupe, mais permettre toujours son utilisation pour les options payantes/gratuites des produits",
    hideNameOnKiosk: "Masquer le nom sur la borne",
    hideNameOnKioskTooltip: "Masque le nom de ce groupe sur la borne : seule son image ou son icône reste affichée. Le groupe reste visible et sélectionnable.",
    maxChoicePaid: "Max payant sous-groupe",
    maxChoiceFree: "Max gratuit sous-groupe",
    maxChoicePaidToolTip: "En attachant ce groupe à un produit, vous pouvez restreindre le nombre de sous-produits payants en utilisant cette option.",
    maxChoiceFreeToolTip: "En attachant ce groupe à un produit, vous pouvez restreindre le nombre de sous-produits gratuits en utilisant cette option.",
    activeHours: "Happy Hours",
    activeHoursToolTip: "Activez/Désactiver pour définir un créneau horaire pendant lequel ce groupe sera visible et disponible à la vente dans la caisse.",
    printOnAllPrinters: "Imprimer sur toutes les imprimantes",
    printOnAllPrintersTooltip: "Si activé, les produits de ce groupe seront imprimés sur toutes les imprimantes assignées au groupe au lieu de demander à l’utilisateur de sélectionner une imprimante lors de la commande.",
    forcedChoiceAmountFree: "Choix gratuits obligatoires",
    forcedChoiceAmountFreeTooltip: "Nombre exact d’options gratuites à sélectionner.",
    forcedChoiceAmountPaid: "Choix payants obligatoires",
    forcedChoiceAmountPaidTooltip: "Nombre exact d’options payantes à sélectionner.",
    allowMultipleChoiceOnSameItems: "Autoriser le choix de sous-options en doublon",
    allowMultipleChoiceOnSameItemsTooltip: "Permet de sélectionner plusieurs fois la même sous-option pour un produit.",
    enablePopup18: "Activer le popup 18",
    enablePopup18Tooltip: "Activer/Désactiver pour afficher un popup de vérification d'age pour ce group dans votre site web.",
    descriptionPopup: "Text du popup",
    enablePopup: "Activer le popup personnalisé",
    enablePopupToolTip: "Affiche une fenêtre personnalisée lorsqu'un produit de ce groupe est sélectionné",
    picto: "Picto",
    enablePopupTooltip: "Activer/Désactiver pour afficher un popup personnalisé pour ce group dans votre site web.",

    assignToAllProduct: "Assigner à tous les produits",
    assignToAllProductTooltip: "Activer cette option pour attribuer ce groupe à tout vos produits",
    assignVatToAllProducts: "Assigner la tva à tous les produits",
    assignVatToAllProductTooltip: "Activer cette option pour attribué la tva de ce group à tout les produits",
};

const kitchenPageStrings = {
    name: "Message cuisine",
    addMessage: "Ajouter un message",
    message: "Message",
    textEnter: "Message : ",
    erText: 'Message requis',
    noFundResultTable: "Aucun message trouvé.",
}

const catalogPageStrings = {
    exportProducts: "Exporter les produits",
    exportTemplate: "Exporter le modèle",
    exportLegacy: "Export (Legacy)",
    openGroup: "Ouvrir le groupe",
    showProducts: "Afficher les produits",
    hideProducts: "Masquer les produits",
    expandGroup: "Déplier le groupe",
    collapseGroup: "Replier le groupe",
    productsCount: "aucun produit | 1 produit | {count} produits",
    subgroupsCount: "aucun sous-groupe | 1 sous-groupe | {count} sous-groupes",
    itemsCount: "aucun élément | {count} élément | {count} éléments",
    moveSelection: "Déplacer la sélection ({count})",
    inheritedSelectionDisabled: "La sélection est désactivée pour les éléments hérités de l'organisation parente",
    editGroups: "Modifier le groupe | Modifier les {count} groupes",
    deleteGroups: "Supprimer le groupe | Supprimer les {count} groupes",
    editProducts: "Modifier le produit | Modifier les {count} produits",
    deleteProducts: "Supprimer le produit | Supprimer les {count} produits",
    downloadSelection: "Télécharger ({count})",
}

const productOptionsPageStrings = {
    duplicateList: "Dupliquer la liste",
    duplicateWithItems: "Inclure les options de la liste dans la duplication ?",
    copyName: "{name} (copie)",
    name: "Listes d'options",
    addList: "Créer une liste",
    searchPlaceholder: "Rechercher une liste",
    empty: "Aucune liste d'options",
    nameFR: "Nom (FR)",
    nameNL: "Nom (NL)",
    nameBase: "Nom (base)",
    minChoiceTotal: "Choix minimum",
    maxChoiceTotal: "Choix maximum",
    forceChoiceTotal: "Choix imposés",
    minChoiceTotalTooltip: "Nombre minimum d'options à choisir dans cette liste",
    maxChoiceTotalTooltip: "Nombre maximum d'options à choisir dans cette liste",
    forceChoiceTotalTooltip: "Nombre exact d'options à choisir dans cette liste",
    forceOverridesMinMax: "Un nombre de choix est imposé : le minimum et le maximum ne sont plus pris en compte.",
    newList: "Nouvelle liste",
    createList: "Créer la liste",
    selectListHint: "Sélectionnez une liste ou créez-en une nouvelle",
    sectionName: "Nom",
    sectionRules: "Règles de choix",
    sectionProducts: "Produits",
    sectionPrice: "Prix",
    sectionSettings: "Paramètres",
    free: "Gratuite",
    freeTooltip: "Cette option sera considérée comme gratuite lors de la prise de commande",
    multiple: "Multiple",
    price: "Prix",
    priceInOut: "Prix In/Out",
    priceOnSite: "Prix sur place",
    priceTakeaway: "Prix à emporter",
    priceTooltip: "Prix de l'option ; laisser vide pour garder le prix normal du produit",
    priceTakeawayTooltip: "Prix de l'option à emporter ; laisser vide pour garder le prix normal du produit",
    pricePerPlatform: "Prix par plateforme (In/Out)",
    pricePerPlatformTooltip: "Prix sur place et à emporter par plateforme ; laisser vide pour garder le prix normal du produit",
    typeLabel: "Type d'option",
    typePrefix: "Préfixe",
    actionsTooltip: "Réordonner, modifier ou retirer l'option",
    typeTooltip: "Type particulier d'option, ex : \"Sans\" pour retirer un ingrédient",
    unsavedChangesConfirm: "Des modifications ne sont pas enregistrées. Voulez-vous les abandonner ?",
    productsCount: "aucun produit | {count} produit | {count} produits",
    addExistingProduct: "Ajouter un produit existant",
    createProduct: "Nouveau produit",
    createGroup: "Nouveau groupe",
    otherGroup: "Autres",
    noItems: "Aucune option dans cette liste",
    inherited: "Héritée",
    inheritedTooltip: "Liste héritée de l'organisation parente : lecture seule",
    typeWith: "Avec",
    typeWithout: "Sans",
    allowMultipleChoice: "Choix multiple autorisé",
    allowMultipleChoiceTooltip: "L'option peut être prise plusieurs fois dans la même commande",
    maxChoice: "Nombre maximum de fois",
    maxChoiceTooltip: "Nombre maximum de fois que cette option peut être choisie dans une commande",
    includeOptionLists: "Inclure les listes d'options du produit",
    includeOptionListsTooltip: "Les listes d'options propres à ce produit sont aussi proposées quand cette option est choisie",
    validation: {
        name: "Au moins un nom est requis",
        minMax: "Le minimum doit être inférieur ou égal au maximum",
        negative: "Les valeurs doivent être positives"
    }
};

const productPageStrings = {
    zeroVatConfirm: "Ce produit a une TVA à 0%. Êtes-vous sûr de vouloir l'enregistrer avec une TVA à 0% ?",
    zeroVatConfirmMany: "{count} produit(s) ont une TVA à 0%. Êtes-vous sûr de vouloir les enregistrer avec une TVA à 0% ?",
    favorite: "Favori",
    ingredient: "Ingrédient",
    optionLists: "Listes d'options",
    addOptionLists: "Assigner des options",
    priceBasis: "Baser le prix sur",
    priceBasisTooltip: "Copie le prix choisi de chaque produit dans l'autre prix. Utile quand seul le prix sur place est renseigné.",
    priceBasisIn: "Prix sur place",
    priceBasisOut: "Prix à emporter",
    visibilityApp: "Visible sur la caisse",
    name: "Nom du produit",
    products: "Produits",
    addProduct: "Ajouter un produit",
    noProductInGroup: "Aucun produit dans ce groupe",
    priceVatInclIn: "Prix d'entrée",
    priceVatInclOut: "Prix de sortie",
    vatIn: "TVA entrée",
    vatOut: "TVA sortie",
    codeBarre: "Code-barres",
    optionOrderIndex: "Ordre de l'option",
    extraImageUrls: "URL d'images supplémentaires en https",
    extraImageUrlsTooltip: "Saisissez vos URL d’images supplémentaires, qui seront utilisées pour afficher les images du produit sur votre site web. Veillez à séparer chaque URL par une virgule et à terminer également par une virgule.",
    parentProduct: "Produit parent pour la commande en ligne",
    parentProductTooltip: "Ce produit est un enfant du produit sélectionné et apparaîtra comme une option sur la plateforme de commande en ligne.",
    description: "Description",
    stock: "Stock",
    productGroup: "Groupe de produits",
    productGroupParent: "Groupe Parent",
    productGroupOptions: "Options gratuites du groupe de produits",
    productGroupOptionsPaid: "Options payantes du groupe de produits",
    productFilterByCategory: "Filtrer par catégorie",
    timedproduct: "Produit chronométré?",
    allowDecimal: "Autoriser les unités décimales?",
    dynamicPrice: "Prix dynamique?",
    multiChoice: "Choix multiple autorisé?",
    orderIndex: "Ordre",
    weightPrice: "Prix au poids?",
    visibility: "App Visibilité",
    visibilityWeb: "Web Visibilité",
    visibilityKiosk: "Kiosk Visibilité",
    imageUrl: "URL de l'image en https",
    color: "Couleur",
    allergens: "Allergènes",
    userHiddenTooltip: "Masquer ce produit de l'interface utilisateur empêchant les commandes directes de ce produit, mais permettre toujours son utilisation pour les options payantes/gratuites des produits",
    orderTooltip: "Ordre du produit dans la liste, cela sera utilisé pour trier les produits du même groupe par ordre croissant",
    timedProductTooltip: "Lorsqu'il est activé, ce produit démarrera un chronomètre lors de la commande et à la fermeture, utilisera le prix du produit comme prix/minute pour calculer le prix total",
    allowDecimalTooltip: "Permettra à l'utilisateur d'entrer une valeur décimale pour la quantité du produit en appuyant longuement avant de commander ou avant d'envoyer en sélectionnant produit > unités",
    dynamicPriceTooltip: "Cela ignorera le prix ci-dessus et obligera l'utilisateur à entrer un prix lorsque ce produit est sélectionné",
    weightPriceTooltip: "Cela obligera l'utilisateur à entrer un poids en KG lorsque ce produit est sélectionné. Il détectera automatiquement le poids si une balance est connectée",
    promo_percent: "Promotion fixe en %",
    webHiddenTooltip: "Masquer ce groupe de l'interface web empêchant les commandes directes des produits de ce groupe, mais permettre toujours son utilisation pour les options payantes/gratuites des produits",
    tags: "Tags",
    tagsTooltip: "Saisissez vos tags, qui serviront à filtrer vos produits sur votre site web. Veillez à séparer chaque tag par une virgule.",
    enterBarcode: "Entrer un code-barre",
    externalReference: "Référence externe",
    externalReferenceTooltip: "Référence utilisée pour associer ce produit/groupe à un article d’une autre plateforme ou d’un système externe.",
    kioskHidden: "Caché sur kiosk?",
    kioskHiddenTooltip: "Activer cette option pour masquer ce produit/group uniquement sur votre kiosk",
    purchasePriceVatExcl: "Prix d'achat",
    optionsDescription: "Description personnalisée des options",
    optionsDescriptionTooltip: "Définissez une description personnalisée des options à afficher sous le nom du produit à la place des options par défaut (noms des groupes de sous-options assignés)",
};

const stockPageStrings = {
    emptyTable: "Aucun historique trouvé.",
    name: "Nom du produit",
    stock: "Stock",
    productGroup: "Groupe de produits",
    productGroupOptions: "Options gratuites du groupe de produits",
    productGroupOptionsPaid: "Options payantes du groupe de produits",
    productFilterByCategory: "Filtrer par catégorie",
    timedproduct: "Produit chronométré?",
    allowDecimal: "Autoriser les unités décimales?",
    newStock: "Nouveau stock",
    stockVariation: "Variation de stock",
    editedBy: "Modifié par"
};

const tableStrings = {
    name: "Tables",
    addTable: "Ajouter une table",
    nameZones: "Zones",
    selectZone: "Sélectionner des zones",
    addZones: "Ajouter une zone",
    addTableZone: "Ajouter une zone de table",
    nameTypes: "Types",
    selectType: "Sélectionner des types",
    addTypes: "Ajouter un type de table",
    tableNumber: "Numéro de table",
    zoneNumber: "Numéro de zone",
    zoneName: "Nom de la zone",
    typeName: "Nom du type",
    qrAllTables: "Télécharger en ZIP ({count} table) | Télécharger en ZIP ({count} tables)",
    qrNoTables: "Aucune table à générer",
    createZone: "Créer une zone",
    editZone: "Modifier une zone",
    noZone: "Sans zone",
    tableCount: "{count} table | {count} tables",
    emptyTables: "Aucune table",
    invalidColor: "Couleur invalide, utilisez le format #RRGGBB"
};

const paymentsStrings = {
    header: "Transactions de paiement",
    orderId: "ID de commande",
    paymentType: "Type",
    amount: "Montant",
    returned: "Rendu",
    totalCash: "Total espèces",
    totalCard: "Total carte",
    totalOffered: "Total offert",
    totalError: "Total erreur",
    totalVatExcl: "Total HT",
    totalVatIncl: "Total",
    totalCredit: "Total crédit",
    vatValue: "Valeur",
    totalBankTransfer: "Total virement"
};

const orderedProductsString = {
    header: "Historique des commandes",
    accountId: "ID de compte",
    linkedTo: "Lié à"
};

const accountHistory = {
    orderCode: "Code",
    payType: "Paiement",
    source: "Source",
    header: "Historique des comptes",
    filterShift: "Service #{shiftId}",
    filterUser: "Utilisateur #{userId}"
};

const openAccounts = {
    header: "Comptes ouverts",
    type: "Type",
    source: "Source",
    orderCode: "Code commande",
    covers: "Couverts",
    duration: "Durée"
};

const shiftDetail = {
    header: "Détail du service",
    referenceId: "Référence"
};

const shiftStat = {
    header: "Statistiques du service",
    sectionUsers: "Utilisateurs",
    sectionUserShifts: "Services par utilisateur",
    sectionGroups: "Groupes",
    sectionParentGroups: "Groupes parents",
    sectionProducts: "Produits",
    count: "Quantité",
    sales: "Ventes",
    refund: "Remboursements",
    correction: "Corrections",
    otherNeg: "Autres négatifs",
    purchasePrice: "Prix d'achat",
    vatDetails: "Détail TVA",
    totalShifts: "Nombre de services",
    userType: "Type",
    duration: "Durée",
    shift: "Service",
    autoClosed: "Fermeture auto"
};

const shift = {
    openShift: "Heure d'ouverture",
    openUserName: "Utilisateur d'ouverture",
    openUserTime: "Heure d'ouverture",
    openUserCash: "Caisse de départ",
    closeUserName: "Utilisateur de fermeture",
    closeUserTime: "Heure de fermeture",
    closeUserCash: "Caisse de fin",
    totalCash: "Espèces",
    totalCard: "Carte",
    totalOffered: "Offert",
    totalBankTransfer: "Virement",
    totalError: "Erreur",
    totalCredit: "Crédit",
    statistics: "Statistiques",
    total: "Total du service",
    inProgress: "En cours...",
    endComment: "Commentaire sur la fin du service",
    paymentType: "Forcer la fermeture du compte avec un paiement mixte par",
    totalCashClose: "Votre montant total en espèces",
    HeaderShiftClose: "Fermer ce service",
    MessageCloseShift: "Êtes-vous sûr de vouloir terminer le service ? Vous ne pourrez plus rouvrir ce service !",
    MessageOpenShift: "Êtes-vous sûr de vouloir ouvrir un nouveau le service ?",
    noOpenShift: "Aucun service en cours",
    OpenNewShift: "Ouvrir un nouveau service?",
    OpenNewShiftButton: "Ouvrir un service",
    training: "Training"
};

const printerStrings = {
    printers: "Imprimantes",
    addPrinter: "Ajouter une imprimante",
    printerName: "Nom de l'imprimante",
    doublePrint: "Imprimer en double",
    model: "Modèle",
    modelUnset: "-- Sélectionner un modèle --",
    modelHelper: "Modèle d'imprimante Star. Optionnel — laissez vide si inconnu.",
    erName: "Nom requis",
    erIpAddress: "Adresse IP requise",
    modelGroup: {
        desktop: "Comptoir",
        compact: "Compacte / cuisine / kiosque",
        mobile: "Mobile"
    },
    noPrinter: "Aucune imprimante",
    noPrinterHint: "Ajoutez une imprimante pour commencer.",
    editPrinter: "Modifier l'imprimante",
};

const settingsPageStrings = {
    searchPlaceholder: "Rechercher un réglage...",
    status: "Statut de l’organisation",
    settings: "Réglages",
    orderConfirmationEmailBccEnabled: "Emails de confirmation en copie (BCC)",
    orderConfirmationEmailBccEnabledTooltip: "Activez cette option pour recevoir une copie cachée (BCC) de tous les emails de confirmation de commande envoyés aux clients.",
    hasImageBackground: "Image produit avec fond",
    printProductsSectionOnZReport: "Imprimer la section produits sur le rapport Z",
    printProductsSectionOnZReportTooltip: "Inclure la section produits sur le rapport Z lors de la fermeture du service.",
    digitalVatTicketEnabled: "Ticket TVA numérique",
    digitalVatTicketEnabledTooltip: "Activer la génération de tickets TVA numériques pour cette organisation",
    printStatusUrlQrCode: "Imprimer le QR code de suivi",
    printStatusUrlQrCodeTooltip: "Imprime un QR code sur les tickets et les écrans kiosque permettant aux clients de suivre leur commande en ligne.",
    masterKioskOrgEnabled: "Mode kiosque maitre",
    masterKioskOrgEnabledTooltip: "Permet aux bornes kiosque de basculer entre les organisations enfants (ex. enseignes d'un food court).",
    masterKioskIncludeMasterInPicker: "Inclure l'organisation maître dans le sélecteur",
    masterKioskIncludeMasterInPickerTooltip: "Affiche cette organisation comme option dans l'écran de sélection du kiosque, avec les organisations enfants.",
    dataChangeLock: "Verrouiller les modifications",
    dataChangeLockTooltip: "En activant cette option, seuls les super-utilisateurs pourront effectuer des modifications dans les paramètres simple de l'organisation.",
    partnerSource: "Source partenaire",
    partnerSourceTooltip: "Identifie le partenaire/revendeur auquel cette organisation appartient. Seuls les super utilisateurs ayant la même source partenaire peuvent gérer cette organisation ; laissez vide pour une organisation gérée globalement.",
    supportChatCrispEnabled: "Chat d'assistance Crisp",
    supportChatCrispEnabledTooltip: "Affiche la fenêtre de chat Crisp à cette organisation afin qu'elle puisse contacter l'assistance directement depuis l'application. Désactivez-la pour masquer la fenêtre pour ce client.",
    supportVipEnabled: "Assistance VIP",
    supportVipEnabledTooltip: "Marque cette organisation comme client prioritaire afin que ses demandes d'assistance soient traitées en premier.",
    kioskOrderActive: "Activer les commandes kiosk",
    kioskOrderActiveTooltip: "En activant cette option, les clients pourront passer commande depuis le kiosk.",
    vwActivationMerchantApiKey: "Clé API marchand d’activation Viva Wallet",
    vwActivationMerchantApiSecret: "Secret API marchand d’activation Viva Wallet",
    vwActivationPin: "Code PIN d’activation Viva Wallet",
    shiftCounterEnabled: "Activer le compteur de tickets par shift",
    shiftCounterEnabledTooltip: "Lorsqu’il est activé, les compteurs de tickets sont réinitialisés automatiquement à la fin de chaque shift.",
    brandColors: "Couleurs de la marque",
    brandColor: "Couleur principale",
    brandSecondaryColor: "Couleur secondaire",
    brandTertiaryColor: "Couleur tertiaire",
    applyKioskBrandColors: "Appliquer les couleurs de la marque sur la borne",
    applyKioskBrandColorsTooltip: "Si activé, la borne utilise les couleurs de votre marque au lieu du thème par défaut.",
    onlineOrderVersion: "Version de l'Online Order",
    bank: "Banque",
    suSectionOrganisation: "Organisation",
    suSectionPeppol: "Peppol",
    suSectionKitchenDisplay: "Écran cuisine",
    suSectionDigitalMenu: "Menu digital",
    suSectionWebshop: "Boutique en ligne",
    suSectionGoogleMaps: "Google Maps",
    suSectionDeviceManagement: "Gestion des appareils",
    suSectionShiftUser: "Services des employés",
    suSectionParentOrganisation: "Organisation parente",
    bankIban: "IBAN",
    bankName: "Nom",
    bankBic: "Code BIC",
    peppolEnabled: "Activer peppol",
    peppolEnabledTooltip: "Active l'intégration Peppol pour permettre l'envoi et la réception de documents électroniques compatibles.",
    name: "Votre organisation",
    organisationId: "Code de l'organisation",
    organisationName: "Nom",
    vatNumber: "Numéro de TVA",
    digitalMenuEnabled: "Activer le menu digital",
    digitalMenuEnabledTooltip: "Active le menu digital lié à cette organisation pour les supports compatibles.",
    address: "Adresse",
    searchAddress: "Rechercher votre adresse (rue et numéro)",
    noAddressFound: "Aucune adresse trouvée",
    addressWithoutNumber: "Veuillez inclure votre numéro de rue dans la recherche",
    selectAddressFromList: "Veuillez sélectionner votre adresse parmi les suggestions",
    addressSearchUnavailable: "La recherche d'adresse est indisponible pour le moment",
    telephone: "Téléphone",
    contactEmail: "Email de contact",
    website: "Site web",
    includeParentProductsHint: "Inclure les produits de l'organisation parente",
    includeParentProductsTooltip: "Inclut les produits des organisations parentes UNIQUEMENT dans l'application si cette organisation a une organisation parente.",
    parentOrgId: "ID de l'organisation parente",
    parentOrgIdTooltip: "Définit l'organisation parente utilisée pour l'héritage de certains paramètres, produits ou comportements.",
    autoPrintVatTicket: "Impression auto du ticket TVA",
    autoPrintVatTicketTooltip: "Permet d'imprimer automatiquement le ticket TVA après chaque paiement",
    mainPrinterIpAddress: "Adresse IP de l'imprimante principale",
    takeawaySectionEnabled: "Section à emporter",
    takeawaySectionEnabledTooltip: "Active une section 'à Emporter' sur l'accueil",
    tableSectionEnabled: "Section des tables",
    tableSectionEnabledTooltip: "Active une section pour les tables sur l'accueil",
    shiftEnabled: "Service activé",
    printerSettings: "Impression",
    vivaWallet: "Viva Wallet",
    webSettings: "Paramètre de commande online",
    superSettings: "Super user",
    kitchenTopSpacing: "Espacement en haut de la cuisine",
    kitchenTopSpacingTooltip: "Ajuster l'espace qu'il y a au dessus de la cuisine pour améliorer votre confort visuel",
    kitchenGroupItems: "Regrouper les éléments de la cuisine",
    kitchenGroupItemsTooltip: "En activant cette option les éléments de la cuisine seront regroupés",
    charactersPerLine: "Caractères par ligne",
    charactersPerLineTooltip: "Definissez le nombre de caractères autorisés par ligne",
    bigKitchenFontSize: "Police d'écriture large pour cuisine",
    bigKitchenFontSizeTooltip: "Aggrandit la police d'écriture pour la cuisine afin d'avoir une meilleure visibilité",
    pinLockTimeout: "Délai de verrouillage par code PIN (secondes)",
    promptCoversEnabled: "Demander le nombre de couverts",
    promptCoversEnabledTooltip: "À l'ouverture d'une table ou d'une commande, le personnel indique le nombre de convives.",
    pinLockEnabled: "Verrouillage par code PIN",
    kitchenPrintEnabled: "Imprimer le ticket de commande",
    autoCloseAccountOnPaymentEnabled: "Fermer le compte après paiement",
    kioskAutoCloseAccountOnPaymentEnabled: "Clôturer automatiquement les commandes borne après paiement",
    kioskAutoCloseAccountOnPaymentEnabledTooltip: "Les commandes payées à la borne sont clôturées directement au lieu de rester dans la liste des comptes payés.",
    onlineOrderAutoCloseAccountOnPaymentEnabled: "Clôturer automatiquement les commandes en ligne après paiement",
    onlineOrderAutoCloseAccountOnPaymentEnabledTooltip: "Les commandes web payées en ligne sont clôturées directement au lieu de rester dans la liste des comptes payés.",
    autoPrintSummaryTicketEnabled: "Imprimer automatiquement le ticket après paiement",
    autoPrintSummaryOnCashOrderKiosk: "Imprimer automatiquement le ticket après un paiement en espèces sur le kiosk",
    autoPrintSummaryOnCashOrderOnlineOrder: "Imprimer automatiquement le ticket après un paiement en espèces sur le webshop",
    autoPrintShiftXY: "Imprimer automatiquement Z",
    hideShiftInfo: "Masquer les informations du service",
    paymentTypeOfferedEnabled: "Autoriser mode de paiement offert",
    paymentTypeTransferEnabled: "Autoriser mode de paiement virement bancaire",
    sendOrderBehavior: "Action après envoi",
    autoOpenCashRegister: "Ouvrir automatiquement la caisse enregistreuse",
    DEFAULT: "PAR DÉFAUT",
    NAV_BACK: "RETOUR",
    NAV_PAYMENT: "ALLER AU PAIEMENT",
    orgaFlag: "Application",
    refundEnabled: "Autoriser le remboursement",
    addItemsToTop: "Nouveau produit en haut",
    autoOpenNewAccount: "Ouverture auto d'un nouveau compte",
    normalAccountOpenButton: "Bouton '+' pour ouvrir un compte",
    removeStockFromParentOrgHint: "Retirer le stock de l'organisation parente à la commande",
    removeStockFromParentOrgTooltip: "Active cette option pour retirer automatiquement le stock de l'organisation parente lors des commandes.",
    vwIsvAmount: "Montant ISV",
    vwEnabled: "VW activé",
    vwTerminalMerchantId: "ID de marchand ISV",
    vwTerminalId: "ID de terminal (pour les terminaux NEXT)",
    mapsAutoCompleteEnabled: "Intégration Google Maps",
    mapsAutoCompleteEnabledTooltip: "Active l'intégration Google Maps pour l'autocomplétion des adresses et l'assistance à la localisation.",
    autoAssignDeviceToMainType: "Affecter automatiquement l'appareil au type principal",
    autoAssignDeviceToMainTypeTooltip: "Affecte automatiquement les nouveaux appareils au type principal configuré pour cette organisation.",
    workerShiftsEnabled: "Activer les shift utilisateurs (Pointeuse)",
    workerShiftsEnabledTooltip: "Active le suivi des shifts utilisateurs et la logique de pointeuse pour cette organisation.",
    pinLockTooltip: "Exiger un code PIN pour accéder à l'application",
    shiftsTooltip: "Activer le système de service, cela obligera l'utilisateur à ouvrir un service avant d'utiliser l'application et à le fermer à la fin de chaque service",
    printOrderTicketTooltip: "Activer l'impression d'un ticket lors de l'envoi d'une commande à la cuisine",
    closeAccountAfterPaymentTooltip: "Fermer automatiquement le compte après un paiement",
    autoPrintSummaryTicketTooltip: "Imprimer automatiquement un ticket récapitulatif après un paiement",
    autoPrintKioskTooltip: "Imprimer automatiquement un ticket récapitulatif après un paiement sur le kiosk",
    autoPrintOnlineOrderTooltip: "Imprimer automatiquement un ticket récapitulatif après un paiement sur le webshop",
    allowOfferTooltip: "Activer le bouton d'offre sur l'écran de paiement pour TOUS les utilisateurs",
    actionAfterSendTooltip: `Choisissez ce qui se passe après l'envoi d'une commande à la cuisine : 
 - PAR DÉFAUT: Rester sur l'écran de commande 
 - RETOUR: Retourner à l'écran de commande 
 - ALLER AU PAIEMENT: Aller à l'écran de paiement`,
    openCashRegisterTooltip: "Ouvrir automatiquement la caisse enregistreuse lorsqu'un paiement en espèces est effectué après la confirmation du paiement",
    autoPrintShiftXZTooltip: "Imprimer automatiquement le X/Z sur l'imprimante lorsque le service est fermé dans l'application",
    hideShiftInfoTooltip: "Masquer les informations du service telles que le type de paiement et le montant total du service sur la page de gestion des services dans l'application",
    allowBankTransferTooltip: "Activer le mode de paiement par virement bancaire sur l'écran de paiement pour TOUS les utilisateurs",
    allowRefundTooltip: "Activer le bouton de remboursement dans un compte à partir de l'historique pour TOUS les utilisateurs",
    newProductOnTopTooltip: "Lorsqu'il est activé, un produit ajouté à un compte/table apparaîtra en haut de la liste au lieu du bas",
    autoOpenNewAccountTooltip: "Crée un nouveau compte dès que le précédent est fermé",
    separateInDeliveryTakeawayTooltip: "affiche uniquement un bouton '+' pour ouvrir un compte",
    subSectionPayment: "Paiement",
    subSectionHome: "Écran d'accueil",
    subSectionShift: "Service",
    subSectionOrdering: "Commande",
    subSectionWebsite: "Website",
    mainPrinterTooltip: "L'adresse IP de l'imprimante principale qui sera utilisée pour imprimer les tickets de TVA/récapitulatifs par defaut",
    pinLockTimeoutTooltip: "Le délai en secondes avant que le verrouillage par code PIN ne soit activé.",
    onlineOrderWebPageEnabled: "Commande online active",
    onlineOrderWebPageEnabledTooltip: "Active le webshop de commande en ligne pour cette organisation.",
    onlineOrderOpen: "Commande online ouverte",
    onlineOrderOpenTooltip: "Active ou désactive temporairement la prise de commandes sur le webshop sans désactiver entièrement le site de commande.",
    onlineOrderDeliveryEnabled: "Livraison disponible",
    onlineOrderDeliveryEnabledTooltip: "Permet aux clients de choisir la livraison comme mode de commande sur le webshop.",
    onlineOrderPickupEnabled: "Pickup disponible",
    onlineOrderPickupEnabledTooltip: "Permet aux clients de choisir le retrait sur place comme mode de commande sur le webshop.",
    payOnlineEnabled: "Paiement online disponible",
    payOnlineEnabledTooltip: "Active le paiement en ligne lors de la validation d'une commande sur le webshop.",
    payAtPickupEnabled: "Paiement après commande disponible",
    payAtPickupEnabledTooltip: "Permet aux clients de payer au retrait ou à la réception plutôt qu'en ligne lors de la commande.",
    onlineOrderHideNoStockProducts: "Uniquement les produits avec stock disponible",
    onlineOrderHideNoStockProductsTooltip: "Masque du webshop les produits qui ne sont plus en stock.",
    logoImageUrl: "Logo",
    logoImageUrlTooltip: "Logo de votre organisation. Importez un PNG ou collez son URL.",
    ticketLogoImageUrl: "Logo des tickets (png)",
    ticketLogoImageUrlTooltip: "Logo imprimé sur les tickets. Importez un PNG ou collez son URL.",
    bannerImageUrl: "Bannière",
    bannerImageUrlTooltip: "Bannière affichée sur votre boutique en ligne. Importez une image ou collez son URL.",
    hideProductImagesInApp: "Cacher les images sur l'app",
    hideProductImagesInAppTooltip: "Masque les images produits sur l'application",
    webOrgaName: "Nom de l'organisation pour le site web",
    autoPrintSummaryTicketOnSend: "Imprimer automatiquement le ticket de résumé à l'envoi d'une commande",
    autoPrintSummaryTicketOnSendTooltip: "Active l'impression automatique du ticket de résumé lorsqu'une commande est envoyée",
    autoPrintVatTicketOnSend: "Impression auto du ticket TVA",
    autoPrintVatTicketOnSendTooltip: "Permettre d'imprimer automatiquement le ticket TVA après l'envoi d'une commande",
    subscriptionEnd: "Fin d'abonnement",
    subscriptionEndTooltip: "Définit la date et l'heure de fin d'abonnement de l'organisation.",
    onlineOrderMinAmount: "Montant minimum pour commande",
    onlineOrderMinAmountTooltip: "Montant minimum requis pour permettre au client de valider une commande sur le webshop.",
    onlineOrderPromoCodeInputEnabled: "Champ code promo",
    onlineOrderPromoCodeInputEnabledTooltip: "Affiche le champ de saisie du code promo sur le webshop lors de la validation de la commande.",
    onlineOrderExecutionTimeInputEnabled: "Choix de l'heure de commande",
    onlineOrderExecutionTimeInputEnabledTooltip: "Permet au client de choisir l'heure d'exécution de sa commande sur le webshop.",
    onlineOrderExecutionTimeEatInEnabled: "Choix de l'heure sur place",
    onlineOrderExecutionTimeEatInEnabledTooltip: "Permet de choisir l'heure d'exécution aussi pour les commandes sur place.",
    onlineOrderMinExecutionDelayMinutes: "Délai minimum d'exécution (minutes)",
    onlineOrderMinExecutionDelayMinutesTooltip: "Délai minimum en minutes entre la validation de la commande et l'heure d'exécution la plus proche proposée.",
    accountBankName: "Compte en banque",
    eatInEnabled: "Repas sur place",
    eatInEnabledTooltip: "Permet aux clients de choisir la consommation sur place comme mode de commande sur le webshop.",
    autoGroupingEnabled: "Activer le regroupement des produits",
    autoGroupingEnabledTooltip: "Lorsque cette option est activée, les articles commandés de manière consécutive seront automatiquement regroupés en une ligne unique (ex. : 3 × Item A), afin de simplifier l'affichage de la commande.",
    onlineOrderBankTransferEnabled:"Payment par virement bancaire",
    onlineOrderBankTransferEnabledTooltip: "Autorise le paiement par virement bancaire pour les commandes passées sur le webshop.",
    kiosk: "Kiosk",
    kioskBackgroundVideoUrl: "URL de la vidéo de fond",
    kioskBackgroundVideoUrlTooltip: "Vidéo diffusée en fond sur la borne. Importez un MP4 ou collez son URL.",
    customWebshopDomain: "Nom de domaine personnalisé",
    customWebshopDomainTooltip: "Permet d'associer un domaine personnalisé au webshop de cette organisation.",
    webOrgaNameTooltip: "Identifiant ou nom utilisé par le site webshop pour retrouver cette organisation.",
    shiftAutoOpen: "Ouverture automatique du shift",
    shiftAutoOpenTooltip: "Activez cette option pour ouvrir automatiquement votre shift",
    shiftAutoClose: "Fermeture automatique du shift",
    shiftAutoCloseTooltip: "Activez cette option pour clôturer automatiquement votre shift",
    showShiftHours: "Definir des heures de fermeture automatiques",
    uiStateOrderProductGroupDoubleCols: "Afficher les groupes en deux colonnes",
    uiStateOrderProductGroupDoubleColsTooltip: "En activant cette option, les groupes de produits sur votre caisse seront affichés en deux colonnes au lieu d'une.",
    kitchenDisplayEnabled: "Activer l'écran Cuisine",
    kitchenDisplayEnabledTooltip: "Active l'écran cuisine pour afficher les commandes en préparation dans l'organisation.",
    kitchenDisplayAutoPrintOnStateChange: "Impression auto à la fin de la commande",
    kitchenDisplayAutoPrintOnStateChangeTooltip: "Lorsque cette option est activée, un ticket est imprimé automatiquement dès qu’une commande passe au statut 'Completed'.",
    kitchenDisplayPreparingStateEnabled: "Activer la section de préparation",
    kitchenDisplayPreparingStateEnabledTooltip: "Lorsque cette option est activée, une section 'en preparation' s'affiche afin de voir les commandes en cours de préparation.",
    kioskOrderNameRequired: "Demander le nom du client",
    kioskOrderNameRequiredTooltip: "En activant cette option, une section apparaitra pour enregistrer le nom du client sur le ticket de commande",
    kioskBuzzerNumberRequired: "Demander le numéro de buzzer",
    kioskBuzzerNumberRequiredTooltip: "En activant cette option, une section apparaitra pour enregistrer le numéro de buzzer sur le ticket de commande",
    active: "Actif",
    blocked: "Bloqué",
    behindPayment: "Retard de paiement",
    inactive: "Inactif",
    statusTooltip: "Définit si l'organisation est active ou bloquée dans le système.",
    printPhoneOnTicket: "Imprimer le numéro de téléphone sur le ticket",
    printPhoneOnTicketTooltip: "Imprimer le numéro de téléphone de l’organisation sur les tickets Proforma et TVA",
    ticketHeaderText: "Texte d'en-tête du ticket",
    ticketHeaderTextTooltip: "Texte imprimé en haut de chaque ticket, au-dessus du détail de la commande. Utilisez-le pour un message de bienvenue ou vos heures d'ouverture. Maximum 500 caractères.",
    ticketFooterText: "Texte de pied de page du ticket",
    ticketFooterTextTooltip: "Texte imprimé en bas de chaque ticket, sous le total. Utilisez-le pour remercier vos clients ou indiquer votre site web. Maximum 500 caractères.",
    compressedTicketsEnabled: "Tickets compressés",
    compressedTicketsEnabledTooltip: "Imprimer les tickets dans une mise en page compressée pour économiser du papier pour cette organisation.",
    showDefaultOptionsDescription: "Afficher les options par défaut (kiosk/web)",
    showDefaultOptionsDescriptionTooltip: "Affiche les options sous le produit sur kiosk/web. La caisse utilise les options par défaut.",
    onlineOrderVersionTooltip: "Sélectionnez la version à utiliser pour votre système de commandes en ligne.",
    hasImageBackgroundTooltip: "Permet de definir le style des images pour un meilleur rendu visuel sur le webshop",
    vwEnabledTooltip: "Active l'intégration Viva Wallet pour cette organisation.",
    vwIsvAmountTooltip: "Montant ou taux ISV utilisé dans la configuration Viva Wallet de cette organisation.",
    vwTerminalMerchantIdTooltip: "Identifiant marchand utilisé pour relier cette organisation à son compte Viva Wallet.",
    vwTerminalIdTooltip: "Identifiant du terminal Viva Wallet utilisé pour les paiements cloud/NEXT.",
    vwActivationMerchantApiKeyTooltip: "Clé API marchand utilisée pour l'activation des terminaux Viva Wallet.",
    vwActivationMerchantApiSecretTooltip: "Secret API marchand utilisé pour l'activation des terminaux Viva Wallet.",
    vwActivationPinTooltip: "Code PIN d'activation communiqué par Viva Wallet pour initialiser le terminal.",
    orgTypeTooltip: "Définit la catégorie métier principale de l'organisation afin d'adapter certains comportements et affichages.",
    blackbox: "Blackbox",
    fdmPosId: "Pos Id",
    fdmUrl: "FDM URL",
    blackboxFdmId: "FDM ID",
    blackboxBasicAuth: "FDM Basic Auth",
    blackboxEstablishmentNumber: "Establishment number",
    generateCodeQrTooltip: "Téléchargez le QR code qui mène au site de commande en ligne.",
};

const clientStrings = {
    emptyTable: "Aucun client trouvé.",
    addClient: "Ajouter un client",
    name : "Nom",
    phone: "Téléphone",
    street: "Rue",
    city: "Ville",
    zipCode: "Code Postal",
    number: "Numéro",
    box: "Boite aux lettres",
    business: "Professionnel",
    vat: "N° de TVA",
    email: "Email",
    extra: "Info Supplémentaire",
    erName: "Nom requis",
    erPhone: "Numéro requis",
    erStreet: "Rue requise",
    erCity: "Ville requise",
    erZipCode: "Code postal requis",
    erNumber: "Numéro requis",
    erPhone2: "Numéro invalide",
    erBox: "Boîte aux lettres requise",
    erMail: "Email requis",
    erMail2: "Email invalide",
    erBusiness: "Sélection requise",
    erVat2: "TVA invalide",
    editClient: "Modifier le client",
}


const invoicePageStrings = {
    emptyTable: "Aucune facture trouvée.",
    invoiceNumber: 'N° de facture',
    linkedTicket: 'Ticket lié',
    type: 'Type',
    standard: 'Standard',
    markAsPaid: 'Marquer comme payée',
    sentReminder: "Envoyer un rappel",
    paid: 'Payée',
    waiting: 'En attente',
    lastReminder: "Dernier rappel",
    markPaidQuestion: 'Voulez-vous marquer cette facture comme payée?',
    invoice: 'Facture',
    editInvoice: "Modifier la facture",
};

const promoPageStrings = {
    emptyTable: "Aucun code promo trouvé.",
    addPromo: "Ajouter une promotion",
    promoCode: 'Code promo',
    discountAmount: "Montant",
    maxUses: "Usage max",
    usedCount: 'Utilisation actuel',
    erPromoCode: 'Promo code non valide',
    erPromoCode2: 'Promo code doit contenir que des lettres et chiffres',
    erMaxUses: 'Champ requis',
    erDiscountAmount: 'Montant supérieur à 0',
    erUsedCount: 'Champ requis',
    validityPeriod: "Période de validité",
    erValidityPeriod: "Sélectionnez une date de début et de fin",
    erMAmount: "M doit être un entier positif",
    erNAmount: "N doit être un entier positif",
    type: "Type",
    percentage: "Pourcentage",
    fixed: "Fixe",

    nAmount: "Montant (N)",
    nAmountTooltip: "Nombre d’articles offerts après l’achat de M articles.",

    mAmount: "Montant (M)",
    mAmountTooltip: "Nombre d’articles que le client doit ajouter au panier pour bénéficier de la promotion.",

    applyGroupId: "Appliquer sur un groupe de produits",
    applyGroupIdTooltip: "Si aucun groupe n’est sélectionné, la promotion s’appliquera à tous les groupes de produits.",

    autoActivate: "Activation auto",
    autoActivateTooltip: "Applique automatiquement cette promotion dans le panier, sans avoir à saisir le code promo (y compris en caisse).",

    mPlusNSamePrice: "M+N au même prix",
    editPromo: "Modifier la promo",
};

const voucherPageStrings = {
    title: 'Vouchers',
    createVouchers: "Créer des vouchers",
    noVoucherFound: 'Aucun voucher trouvé.',

    code: 'Code',
    value: 'Valeur',
    remainingValue: 'Solde restant',
    expiryDate: 'Expiration',
    email: 'Email',
    productGroups: 'Groupes autorisés',
    status: 'Statut',
    createdAt: 'Créé le',
    noExpiry: 'Sans expiration',

    statusActive: 'Actif',
    statusRevoked: 'Révoqué',
    statusExpired: 'Expiré',
    statusDepleted: 'Épuisé',
    statusPartiallyUsed: 'Partiellement utilisé',

    quantity: 'Quantité',
    quantityTooltip: 'Nombre de vouchers à générer dans ce lot (1 à 500).',
    valueTooltip: 'Montant chargé sur chaque voucher du lot.',
    expiryDateTooltip: 'Laisser vide pour un voucher sans expiration.',
    emailTooltip: 'Purement informatif : à qui le voucher a été remis. Aucun mail n\'est envoyé.',
    productGroupsTooltip: 'Restreint le voucher à ces groupes de produits. Laisser vide pour tout le catalogue.',
    valueLockedTooltip: 'Le montant n\'est plus modifiable : ce voucher a déjà été utilisé.',

    createdBatchTitle: 'Vouchers créés',
    createdBatchSubtitle: 'Les codes ont été générés. Téléchargez les cartes à imprimer.',
    downloadPdf: 'Télécharger le PDF',
    downloadSelectionPdf: 'Télécharger les cartes de la sélection',
    downloadAllPdf: 'Télécharger toutes les cartes',
    noVoucherToDownload: 'Aucun voucher à télécharger',
    close: 'Fermer',

    activeToggle: 'Actif',
    activeToggleTooltip: 'Un voucher révoqué reste visible mais n\'est plus utilisable.',
    redemptions: 'Historique d\'utilisation',
    noRedemption: 'Ce voucher n\'a jamais été utilisé.',
    redemptionRemainingAfter: 'Solde après',
    viewAccount: 'Voir la commande',

    erQuantity: 'La quantité doit être comprise entre 1 et 500',
    erValue: 'Le montant doit être supérieur à 0',
    erEmail: 'Adresse email invalide',
    errorPdf: 'Le PDF n\'a pas pu être généré',
    deleteConfirm: 'Ce voucher disparaîtra de la liste et ne sera plus utilisable. Cette action est irréversible.'
};

const pickupPageStrings = {
    addPickup: "Ajouter un point de retrait",
    notFound: 'Aucun pickup trouvé.',
    name: 'Nom',
    address: "Adresse",
    phone: "Téléphone",
    openingHours: "Commande",
    pickupTime: "Ramassage",
    hoursField: "Créneaux horaire",
    day: "Jour",
    type: "Type",
    hour: "Début",
    hour2: "Fin",
    add: "Ajouter",
    erName: "Nom requis",
    erPhone: "Numéro requis",
    erPhone2: "Numéro invalide",
    erAddress: "Adresse requise",
    erSlot: "Veuillez ajouter un créneau",
    editPickup: "Modifier le pickup",
};

const deliveryAreaPageStrings = {
    title: "Zones de livraison",
    newArea: "Nouvelle zone",
    createArea: "Créer une zone",
    addDeliveryArea: "Ajouter une zone de livraison",
    editArea: "Modifier la zone",
    areas: "Zones",
    noAreas: "Aucune zone de livraison pour le moment. Dessinez votre première zone sur la carte.",
    drawHint: "Cliquez sur la carte pour placer les points de votre zone.",
    cancelDrawing: "Annuler",
    finishDrawing: "Terminer la zone",
    undoPoint: "Retirer le dernier point",
    name: "Nom de la zone",
    namePlaceholder: "Ex : Centre-ville",
    price: "Prix de livraison (TVAC)",
    minOrderAmount: "Montant minimum de commande",
    freeDeliveryMinAmount: "Montant minimum pour livraison offerte",
    defaultFromSettingsHint: "Laissez à 0 pour utiliser le montant défini dans les paramètres de l'organisation.",
    amountInvalid: "Le montant doit être supérieur ou égal à 0.",
    orderIndex: "Ordre de priorité",
    orderIndexHint: "Plus le nombre est petit, plus la zone est prioritaire en cas de chevauchement.",
    orderIndexInvalid: "L'ordre de priorité doit être un nombre entier positif.",
    editShapeHint: "Déplacez les points de la zone sélectionnée directement sur la carte.",
    shapeModified: "Forme modifiée",
    saveShape: "Enregistrer la forme",
    resetShape: "Annuler les modifications",
    minPoints: "Une zone doit contenir au moins 3 points.",
    nameRequired: "Le nom de la zone est obligatoire.",
    priceInvalid: "Le prix doit être supérieur ou égal à 0.",
    mapError: "La carte n'a pas pu être chargée.",
    points: "points",
    searchAddressMode: "Adresse",
    searchZoneMode: "Commune",
    searchAddressPlaceholder: "Rechercher une adresse",
    searchZonePlaceholder: "Code postal ou commune (ex : 1140, 1930)",
    surroundZone: "Entourer",
    removeZoneQuery: "Retirer",
    zoneAlreadyAdded: "Zone déjà ajoutée :",
    zoneNotFound: "Aucun contour trouvé pour :",
    searchFailed: "La recherche a échoué.",
    zonesFound: "Contours trouvés",
    discardZones: "Annuler",
    keepZones: "Créer",
    createAreas: "Créer les zones",
    batchHint: "Une zone sera créée par commune, avec les mêmes montants."
};

const websitePageStrings = {
    general: "Général",
    image: "Images",
}

const aiDebuggerStrings = {
    title: "Posbel AI",
    investigationStarted: "Enquête lancée",
    requestType: "Type d'enquête",
    message: "Description du problème",
    messageTooltip: "Obligatoire pour « Autre problème ». Pour les autres types, un détail facultatif sur l'incident.",
    moreOptions: "Plus d'options",
    orgId: "Id de l'organisation",
    orgIdTooltip: "Laisser vide pour enquêter sur l'organisation actuelle.",
    targetUser: "Utilisateur concerné",
    targetUserId: "Id de l'utilisateur concerné",
    targetUserTooltip: "Le compte caisse ou serveur sur lequel l'incident s'est produit. Il doit appartenir à l'organisation enquêtée.",
    accountId: "Id du compte",
    orderCode: "Code de commande",
    transactionId: "Id de transaction",
    paymentTransactionId: "Id de transaction de paiement",
    deviceId: "Id de l'appareil",
    printerId: "Id de l'imprimante",
    timeRange: "Période",
    timeRangeTooltip: "Sans période, les 24 dernières heures sont analysées (7 jours pour « Changements récents du menu »).",
    techMode: "Mode technique",
    techModeDescription: "Un rapport plus technique, destiné aux développeurs.",
    launch: "Lancer l'enquête",
    newInvestigation: "Nouvelle enquête",
    investigations: "Mes enquêtes",
    noInvestigation: "Aucune enquête",
    noInvestigationHint: "Les enquêtes sont conservées 7 jours.",
    showReport: "Voir le rapport",
    showError: "Voir l'erreur",
    hideDetails: "Masquer",
    downloadReport: "Télécharger le rapport",
    downloadError: "Le PDF n'a pas pu être généré.",
    pdfTitle: "Enquête technique Posbel",
    pdfInvestigation: "Enquête",
    pdfStatus: "Statut",
    pdfRequestedBy: "Demandée par",
    pdfCreatedAt: "Créée le",
    pdfCompletedAt: "Terminée le",
    reportEmpty: "Le rapport est vide.",
    requestTypes: {
        PAYMENT_NOT_SENT_TO_TERMINAL: "Paiement non envoyé au terminal",
        KITCHEN_PRINTING_NOT_WORKING: "L'impression cuisine ne fonctionne pas",
        VAT_SUMMARY_TICKETS_NOT_PRINTING: "Les tickets TVA / récapitulatifs ne s'impriment pas",
        PAYMENT_NOT_REGISTERED: "Paiement non enregistré",
        RECENT_MENU_CHANGES: "Changements récents du menu",
        OTHER: "Autre problème",
    },
};

const playlistStrings = {
    loadError: "Impossible de charger les playlists",
    disabledHint: "Le menu digital n'est pas activé pour cette organisation.",
    unavailableTitle: "Menu digital indisponible",
    mediaType: "Type de média",
    groupSectionLabel: "Section {index}",
    editPlaylist: "Modifier la playlist",
    editScene: "Modifier la scène",
    noScene: "Aucune scène dans cette playlist",
    sceneCount: "{count} scène | {count} scènes",
    columnLabel: "Colonne {index}",
    columnHeader: "En-tête de colonne",
    columnSectionCount: "{count} section | {count} sections",
    columnEmpty: "Ajoutez une section pour remplir cette colonne.",
    typeImage: "Image",
    typeVideo: "Vidéo",
    typeMenu: "Menu",
    name: "Nom",
    transitionDuration: "Durée de la transition (sec)",
    transitionType: "Type de transition",
    fade: "Ombre",
    slide: "Glissement",
    addPlaylist: "Ajouter une playlist",
    addScene: "Ajouter une scene",
    playlist: "Playlist",
    productGroups: "Groupes de produits",
    orderIndex: "Ordre",
    duration: "Durée d'affichage",
    contentType: "Type de contenu",
    templateName: "Theme",
    backgroundType: "Type de fond",
    background: "URL du Fond",
    vertical: "TV Verticale",
    template4Config: {
        chipsHeader: "En-tête",
        chipsTheme: "Thème",
        chipsLayout: "Disposition",
        chipsColumns: "Colonnes",
        chipsTypography: "Typographie",
        chipsStyle: "Style",
        subtitleStructure: "Structure",
        subtitleSpacing: "Espacement",
        subtitleOffsets: "Décalages",
        subtitleAlignment: "Alignement",
        subtitleCardPreset: "Style de carte",
        subtitleVisibility: "Visibilité",
        subtitleMainHeader: "En-tête principal",
        subtitleColumnHeader: "En-tête de colonne",
        subtitleMenuContent: "Contenu du menu",
        subtitleColorSection: "Couleur",
        title: "Titre",
        titleTooltip: "Titre principal affiché au-dessus du menu.",
        subtitle: "Sous-titre",
        subtitleTooltip: "Texte secondaire affiché sous le titre principal.",
        headerColumns: "Colonnes du titre",
        headerColumnsTooltip: "Choisissez si le titre principal utilise 1 colonne ou s'étend sur 2 colonnes.",
        firstColumnOnly: "Première colonne uniquement",
        firstTwoColumns: "Deux premières colonnes",
        headerBottomSpacing: "Espace sous le titre",
        headerBottomSpacingTooltip: "Espace vertical entre le titre principal et le contenu des colonnes.",
        headerAlign: "Alignement du titre",
        headerAlignTooltip: "Alignement horizontal du texte du titre principal.",
        titleSize: "Taille du titre",
        titleSizeTooltip: "Taille de police du titre principal.",
        subtitleSize: "Taille du sous-titre",
        subtitleSizeTooltip: "Taille de police du sous-titre principal.",
        titleColor: "Couleur du titre",
        titleColorTooltip: "Couleur du texte du titre principal.",
        subtitleColor: "Couleur du sous-titre",
        subtitleColorTooltip: "Couleur du texte du sous-titre principal.",
        columnTitleColor: "Couleur du titre de colonne",
        columnTitleColorTooltip: "Couleur du texte des titres de colonne.",
        columnSubtitleColor: "Couleur du sous-titre de colonne",
        columnSubtitleColorTooltip: "Couleur du texte des sous-titres de colonne.",
        backgroundColor: "Couleur de fond",
        backgroundColorTooltip: "Couleur de fond globale du template.",
        textColor: "Couleur du texte",
        textColorTooltip: "Couleur de texte par défaut du contenu du menu.",
        groupBackground: "Fond des groupes",
        groupBackgroundTooltip: "Couleur de base utilisée pour le fond des cartes de groupe.",
        accentColor: "Couleur d'accent",
        accentColorTooltip: "Couleur d'accent utilisée pour les mises en avant, titres et prix.",
        language: "Langue",
        languageTooltip: "Langue utilisée pour choisir les descriptions traduites des produits.",
        contentPadding: "Padding du contenu",
        contentPaddingTooltip: "Marge intérieure autour de tout le contenu du menu.",
        showPrices: "Afficher les prix",
        showPricesTooltip: "Affiche ou masque les prix des produits.",
        showEuroSymbol: "Afficher le symbole €",
        showEuroSymbolTooltip: "Afficher ou masquer le symbole euro à côté des prix.",
        showDots: "Afficher les pointillés",
        showDotsTooltip: "Afficher les pointillés entre le nom du produit et le prix.",
        showDescriptions: "Afficher les descriptions",
        showDescriptionsTooltip: "Affiche ou masque les descriptions sous les noms des produits.",
        showProductImage: "Afficher l'image produit",
        showProductImageTooltip: "Affiche une image produit carrée sur chaque ligne produit quand disponible.",
        productImageSize: "Taille image produit",
        productImageSizeTooltip: "Taille carrée en pixels utilisée pour les images produit (largeur et hauteur).",
        productCardStyle: "Style des cartes produit",
        productCardStyleTooltip: "Préréglage visuel utilisé pour le rendu des groupes et produits.",
        columns: "Colonnes",
        columnsTooltip: "Nombre total de colonnes affichées dans le template.",
        columnGap: "Espace entre colonnes",
        columnGapTooltip: "Espace horizontal entre les colonnes.",
        groupSpacing: "Espace entre groupes",
        groupSpacingTooltip: "Espace vertical entre les groupes dans une colonne.",
        leftEmptySpace: "Espace vide à gauche",
        leftEmptySpaceTooltip: "Espace réservé à gauche avant le début des colonnes.",
        rightEmptySpace: "Espace vide à droite",
        rightEmptySpaceTooltip: "Espace réservé à droite après la fin des colonnes.",
        columnHeaderSpacing: "Espace du titre de colonne",
        columnHeaderSpacingTooltip: "Espace entre l'en-tête de colonne et le premier groupe de cette colonne.",
        columnHeaderAlign: "Alignement du titre de colonne",
        columnHeaderAlignTooltip: "Alignement horizontal du titre et sous-titre de colonne.",
        left: "Gauche",
        center: "Centre",
        right: "Droite",
        classic: "Classique",
        modern: "Moderne",
        minimal: "Minimal",
        compact: "Compact",
        clean: "Épuré",
        framed: "Encadré",
        addColumn: "Ajouter une colonne",
        columnHeaderSection: "En-tête de colonne",
        showColumnHeader: "Afficher l'en-tête",
        showColumnHeaderTooltip: "Active ou désactive le bloc titre/sous-titre pour cette colonne.",
        columnTitle: "Titre de colonne",
        columnTitleTooltip: "Titre affiché au-dessus de cette colonne.",
        columnSubtitle: "Sous-titre de colonne",
        columnSubtitleTooltip: "Sous-titre affiché sous le titre de colonne.",
        groupSection: "Section de groupe",
        productGroup: "Groupe de produits",
        productGroupTooltip: "Sélectionnez le groupe de produits affiché dans cette section.",
        selectProductGroup: "Sélectionner un groupe de produits",
        visibleProducts: "Produits visibles",
        visibleProductsTooltip: "Choisissez quels produits du groupe sélectionné sont affichés dans cette section.",
        selectVisibleProducts: "Sélectionner les produits visibles",
        addGroupSection: "Ajouter une section de groupe",
        columnTitleSize: "Taille titre de colonne",
        columnTitleSizeTooltip: "Taille de police des titres de colonne.",
        columnSubtitleSize: "Taille sous-titre de colonne",
        columnSubtitleSizeTooltip: "Taille de police des sous-titres de colonne.",
        groupSize: "Taille du groupe",
        groupSizeTooltip: "Taille de police des titres de groupe.",
        productSize: "Taille du produit",
        productSizeTooltip: "Taille de police des noms de produit.",
        descriptionSize: "Taille de la description",
        descriptionSizeTooltip: "Taille de police des descriptions de produit."
    }
}

const topBarStrings = {
    searchPlaceholder: "Rechercher, naviguer, agir...",
    interfaceSettings: "Paramètres interface",
    openMenu: "Ouvrir le menu",
    account: "Mon compte",
    testEnvironment: "Environnement Test"
};

const preferencesPageStrings = {
    showTableIds: "Afficher les identifiants",
    showTableIdsTooltip: "Affiche une colonne avec l'identifiant technique dans les tableaux. Visible uniquement par les super-utilisateurs.",
    name: "Interface",
    description: "Ces réglages sont propres à ce navigateur et sont enregistrés localement.",
    language: "Langue de l'interface",
    languageTooltip: "Langue de l'administration, indépendante de celle du navigateur.",
    languageAuto: "Automatique",
    languageNl: "Nederlands",
    languageFr: "Français",
    languageEn: "English",
    favorites: "Favoris",
    favoriteLinks: "Liens favoris",
    favoriteLinksTooltip: "Les pages choisies apparaissent dans une section Favoris en haut du menu latéral.",
    sideNavAlwaysExpanded: "Garder le menu latéral ouvert",
    sideNavAlwaysExpandedTooltip: "Le menu latéral reste déployé au lieu de se replier automatiquement."
};

const createOrgPageStrings = {
    validation: {
        name: "Le nom de l'organisation est requis",
        contactEmail: "Une adresse email valide est requise",
        orgType: "Le type d'organisation est requis",
        blackboxFdm: "Le FDM ID est requis",
        establishmentNumber: "Le numéro d'établissement est requis"
    }
};

const importPageStrings = {
    steps: {
        file: {
            label: "Fichier",
            title: "Choisissez le fichier à importer",
            description: "Un classeur Excel exporté depuis Posbel ou rempli à partir du modèle, ou un fichier CSV.",
        },
        columns: {
            label: "Colonnes",
            title: "Correspondance des colonnes",
            description: "Associez chaque colonne de votre fichier à un champ Posbel. Les colonnes ignorées ne sont pas importées.",
        },
        check: {
            label: "Vérification",
            title: "Vérification du fichier",
            description: "Chaque ligne a été contrôlée. Les lignes en erreur seront écartées, les valeurs invalides ignorées.",
        },
        references: {
            label: "Références",
            title: "Références introuvables",
            description: "Associez les noms qui ne correspondent à rien.",
        },
        groups: {
            label: "Groupes",
            title: "Groupes",
            description: "Vérifiez les groupes à créer et ceux qui seront réutilisés.",
        },
        optionLists: {
            label: "Listes d'options",
            title: "Listes d'options",
            description: "Vérifiez les listes et leurs choix.",
        },
        summary: {
            label: "Récapitulatif",
            title: "Récapitulatif",
            description: "Choisissez les produits à importer.",
        },
    },
    dropTitle: "Déposez votre fichier ici",
    dropSubtitle: "ou cliquez pour le choisir",
    readingFile: "Lecture de {file}...",
    templateHint: "Pas encore de fichier ? Partez du modèle : il contient toutes les colonnes, une aide sous chaque en-tête et des exemples.",
    changeFile: "Changer de fichier",
    readyTitle: "Le fichier peut être importé",
    blockedTitle: "Le fichier ne peut pas être importé tel quel",
    blockedDescription: "Corrigez les erreurs générales ci-dessous dans votre fichier, puis rechargez-le.",
    countProducts: "{count} produit | {count} produits",
    countGroups: "{count} groupe | {count} groupes",
    countOptionLists: "{count} liste d'options | {count} listes d'options",
    sheetOf: "sur {count} ligne | sur {count} lignes",
    sheetExcluded: "{count} écartée | {count} écartées",
    sheetWarned: "{count} avertissement | {count} avertissements",
    sheetAllValid: "Tout est valide",
    issuesTitle: "Problèmes trouvés",
    filterAll: "Tous",
    filterErrors: "Erreurs",
    filterWarnings: "Avertissements",
    filterFixed: "Corrigés",
    issueRow: "ligne {row}",
    express: {
        button: "Import express",
        title: "Import express",
        intro: "Les choix proposés par défaut à chaque étape sont appliqués et l'import part directement.",
        notice: "À savoir",
        lines: {
            products: "Produit à importer | Produits à importer",
            groupsCreated: "Groupe à créer | Groupes à créer",
            groupsReused: "Groupe existant réutilisé | Groupes existants réutilisés",
            optionLists: "Liste d'options | Listes d'options",
            excluded: "ligne écartée | lignes écartées",
            existing: "produit déjà dans Posbel ignoré | produits déjà dans Posbel ignorés",
            matched: "nom rapproché automatiquement | noms rapprochés automatiquement",
            renamed: "nom de produit corrigé | noms de produit corrigés",
        },
        blockers: {
            columns: "Associez d'abord les colonnes obligatoires : nom, groupe et prix.",
            blocked: "Le fichier contient une erreur bloquante, corrigez-la à l'étape Vérification.",
            groupVat: "Certains nouveaux groupes n'ont pas de TVA, indiquez-la à l'étape Groupes.",
            noProducts: "Aucun produit à importer.",
        },
    },
    fix: {
        clear: "Vider",
        skip: "Ignorer la ligne",
        newValue: "Nouvelle valeur",
        apply: "Appliquer",
        edited: "Valeur remplacée par « {value} ».",
        cleared: "Case vidée.",
        skipped: "Ligne ignorée, elle ne sera pas importée.",
        skipRows: "Ignorer les lignes",
        editTitle: "Modifier la valeur",
        editManyTitle: "Modifier {count} case | Modifier {count} cases",
        currentValue: "valeur actuelle « {value} »",
        columns: "Colonnes : {columns}",
        mixedColumns: "Les cases viennent de plusieurs colonnes : la même valeur sera appliquée partout.",
        applySuggestion: "Appliquer la proposition",
        applySuggestions: "Appliquer les propositions",
    },
    columns: {
        sheet: "Feuille",
        required: "Obligatoires :",
        ignore: "Ignorer",
        untitled: "Colonne {number}",
        fields: {
            name: "Nom",
            group: "Groupe",
            priceVatInclIn: "Prix sur place",
            priceVatInclOut: "Prix à emporter",
            vatIn: "TVA sur place",
            vatOut: "TVA à emporter",
            barcodes: "Codes-barres",
            descriptionFr: "Description (FR)",
            descriptionNl: "Description (NL)",
            descriptionEn: "Description (EN)",
            color: "Couleur",
            imageUrl: "Image",
            externalReference: "Référence",
            purchasePriceVatExcl: "Prix d'achat HTVA",
            orderIndex: "Ordre",
            userHidden: "Masqué en caisse",
            webHidden: "Masqué sur le web",
            kioskHidden: "Masqué sur la borne",
            dynamicPrice: "Prix dynamique",
            weightPrice: "Prix au poids",
        },
    },
    optionLists: {
        offeredOn: "proposée sur {count} produit | proposée sur {count} produits",
        choiceCount: "{count} choix | {count} choix",
        without: "Sans {name}",
        maxTimes: "{count} fois max",
        multiple: "Plusieurs fois",
        free: "Gratuit",
        pricePerChannel: "Prix par canal",
        noChoice: "Aucun choix dans cette liste.",
    },
    summary: {
        selectedProducts: "{count} produit sur {total} à importer | {count} produits sur {total} à importer",
        optionLists: "{count} liste d'options | {count} listes d'options",
        existing: "{count} produit existe déjà avec ce nom dans ce groupe : il est décoché pour éviter un doublon. | {count} produits existent déjà avec ce nom dans leur groupe : ils sont décochés pour éviter des doublons.",
        existingTag: "Déjà dans Posbel",
        submit: "Importer {count} produit | Importer {count} produits",
        success: "Import terminé",
    },
    groups: {
        setVat: "Définir la TVA",
        toCreate: "{count} groupe à créer | {count} groupes à créer",
        toReuse: "{count} groupe existant réutilisé | {count} groupes existants réutilisés",
        missingVat: "Indiquez la TVA sur place et à emporter de chaque nouveau groupe pour continuer.",
        new: "Nouveau",
        existing: "Déjà dans Posbel",
        unchanged: "Groupe existant, il ne sera pas modifié",
        productCount: "{count} produit | {count} produits",
    },
    references: {
        autoCorrected: "{count} nom reconnu malgré une différence de majuscules, d'accents ou d'espaces. | {count} noms reconnus malgré une différence de majuscules, d'accents ou d'espaces.",
        kinds: {
            group: "Groupes",
            optionList: "Listes d'options",
            product: "Produits des choix",
        },
        create: {
            group: "Créer un nouveau groupe « {value} »",
            optionList: "Créer une nouvelle liste « {value} »",
        },
        replaceWith: "Remplacer par « {value} »",
        ignore: "Ignorer ce choix",
        fromFile: "Dans le fichier",
        fromPosbel: "Déjà dans Posbel",
        ambiguous: "Plusieurs produits portent ce nom",
        rows: "ligne {rows} | lignes {rows}",
        allMatch: "Tous les noms du fichier ont été retrouvés",
    },
    issues: {
        unsupportedFormat: "Format non pris en charge. Utilisez un fichier .xlsx ou .csv.",
        readError: "Le fichier n'a pas pu être lu. Vérifiez qu'il n'est pas abîmé ou protégé par un mot de passe.",
        missingSheet: "L'onglet {sheet} est introuvable dans le fichier.",
        noProducts: "Aucun produit valide à importer.",
        unknownSheet: "Onglet {sheet} inconnu, il est ignoré.",
        optionListsDisabled: "Les listes d'options ne sont pas activées, l'onglet {sheet} est ignoré.",
        unknownColumns: "Colonnes inconnues, ignorées : {columns}.",
        missingColumn: "Colonne obligatoire {column} introuvable. Tout l'onglet est ignoré.",
        required: "Valeur obligatoire manquante. Ligne écartée.",
        invalidNumber: "« {value} » n'est pas un nombre. Ligne écartée.",
        invalidInteger: "« {value} » n'est pas un nombre entier. Ligne écartée.",
        negative: "« {value} » ne peut pas être négatif. Ligne écartée.",
        invalidVat: "« {value} » n'est pas un taux de TVA valide ({rates}). Ligne écartée.",
        invalidBoolean: "« {value} » n'est pas oui ou non. Valeur ignorée.",
        invalidColor: "« {value} » n'est pas une couleur hexadécimale. Valeur ignorée.",
        invalidBarcode: "« {value} » n'est pas un code-barres valide, il ne doit contenir que des chiffres. Valeur ignorée.",
        barcodeTooLong: "Le code-barres « {value} » est trop long pour être enregistré. Valeur ignorée.",
        duplicate: "« {value} » apparaît déjà ligne {row}. Ligne écartée.",
        invalidName: "« {value} » contient des caractères non autorisés. Proposition : « {suggestion} ». Ligne écartée.",
        invalidNameNoSuggestion: "« {value} » ne contient aucun caractère autorisé (lettres, chiffres, espaces et - . , ' \" ( ) & % ° / +). Ligne écartée.",
        tooLong: "« {value} » fait {length} caractères, le maximum est {max}. Ligne écartée.",
        duplicateBarcode: "Le code-barres {value} est déjà utilisé ligne {row}. Ligne écartée.",
    },
};

const catalogWorkbookStrings = {
    required: "Obligatoire",
    optional: "Facultatif",
    validation: {
        title: "Valeur non valide",
        reference: "Choisissez une valeur de la liste, qui vient de l'onglet {sheet}. Pour une nouvelle valeur, ajoutez-la d'abord dans l'onglet {sheet}.",
        boolean: "Choisissez {yes} ou {no}.",
        vat: "Choisissez un taux de TVA : {rates}.",
    },
    help: {
        products: {
            name: "Nom du produit.",
            group: "Groupe du produit, avec le chemin complet pour un sous-groupe : {example}. Choisissez un groupe de l'onglet Groups ou écrivez-en un nouveau : il sera créé pendant l'import.",
            priceVatInclIn: "Prix TVAC sur place.",
            priceVatInclOut: "Prix TVAC à emporter. Vide = même prix que sur place.",
            vatIn: "Taux de TVA sur place en pourcentage : 0, 6, 12 ou 21. Vide = TVA du groupe.",
            vatOut: "Taux de TVA à emporter en pourcentage. Vide = même taux que sur place.",
            barcodes: "Codes-barres, plusieurs séparés par une virgule.",
            descriptionFr: "Description en français.",
            descriptionNl: "Description en néerlandais.",
            descriptionEn: "Description en anglais.",
            color: "Couleur du bouton au format hexadécimal : {example}.",
            imageUrl: "Lien https vers l'image du produit.",
            externalReference: "Votre propre référence (code article, SKU...).",
            purchasePriceVatExcl: "Prix d'achat HTVA.",
            orderIndex: "Position d'affichage dans le groupe, nombre entier.",
            userHidden: "Masquer le produit sur la caisse. Vide = non.",
            webHidden: "Masquer le produit sur la commande en ligne. Vide = non.",
            kioskHidden: "Masquer le produit sur la borne. Vide = non.",
            dynamicPrice: "Prix dynamique : le prix est saisi à la caisse quand on choisit le produit, le prix de la ligne est ignoré. Vide = non.",
            weightPrice: "Prix au poids : le prix de la ligne est un prix au kilo et le poids est demandé quand on choisit le produit. Vide = non.",
            optionLists: "Listes d'options proposées quand on commande ce produit, par leur nom (colonne name de l'onglet OptionLists), plusieurs séparées par une virgule, dans l'ordre d'affichage.",
            freeOptionGroups: "Ancien système d'options : groupes dont les produits sont proposés gratuitement, plusieurs séparés par une virgule.",
            paidOptionGroups: "Ancien système d'options : groupes dont les produits sont proposés en payant, plusieurs séparés par une virgule.",
            productId: "Identifiant Posbel du produit. Rempli à l'export, ignoré à l'import.",
            stock: "Stock actuel. Rempli à l'export, ignoré à l'import.",
        },
        groups: {
            path: "Chemin complet du groupe : {example}. Un groupe parent doit avoir sa propre ligne.",
            vatIn: "TVA sur place par défaut des produits du groupe, en pourcentage.",
            vatOut: "TVA à emporter par défaut des produits du groupe, en pourcentage.",
            color: "Couleur du groupe au format hexadécimal : {example}.",
            orderIndex: "Position d'affichage du groupe, nombre entier.",
            userHidden: "Masquer le groupe sur la caisse. Vide = non.",
            webHidden: "Masquer le groupe sur la commande en ligne. Vide = non.",
            kioskHidden: "Masquer le groupe sur la borne. Vide = non.",
            imageUrl: "Lien https vers l'image du groupe.",
            externalReference: "Votre propre référence.",
            maxChoiceFree: "Ancien système d'options : nombre maximum de choix gratuits dans ce groupe.",
            maxChoicePaid: "Ancien système d'options : nombre maximum de choix payants dans ce groupe.",
            forceChoiceAmountFree: "Ancien système d'options : nombre de choix gratuits imposés.",
            forceChoiceAmountPaid: "Ancien système d'options : nombre de choix payants imposés.",
        },
        optionLists: {
            name: "Nom de la liste. C'est ce nom qu'on écrit dans la colonne optionLists des produits et dans la colonne list des choix.",
            nameFr: "Nom affiché en français. Vide = la colonne name.",
            nameNl: "Nom affiché en néerlandais. Vide = la colonne name.",
            nameEn: "Nom affiché en anglais. Vide = la colonne name.",
            descriptionFr: "Description en français.",
            descriptionNl: "Description en néerlandais.",
            descriptionEn: "Description en anglais.",
            minChoice: "Nombre minimum de choix. Vide = pas de minimum.",
            maxChoice: "Nombre maximum de choix. Vide = pas de maximum.",
            forceChoice: "Nombre exact de choix imposé. Vide = pas imposé.",
        },
        optionListItems: {
            list: "Nom de la liste (colonne name de l'onglet OptionLists). L'ordre des lignes donne l'ordre des choix dans la liste.",
            product: "Nom du produit proposé comme choix (onglet Products).",
            productGroup: "Groupe du produit. Utile seulement si deux produits portent le même nom.",
            free: "Choix gratuit. Vide = non.",
            without: "Choix « Sans ... » : le client retire ce produit. Vide = non.",
            allowMultipleChoice: "Le client peut prendre ce choix plusieurs fois. Vide = non.",
            maxChoice: "Nombre de fois maximum pour ce choix. Vide = sans limite.",
            includeOptionLists: "Quand ce choix est pris, proposer aussi les listes d'options du produit. Vide = non.",
            priceIn: "Prix spécial sur place pour tous les canaux. Vide = prix du produit.",
            priceOut: "Prix spécial à emporter pour tous les canaux. Vide = prix du produit.",
            priceAppIn: "Prix spécial sur place sur la caisse. Remplace priceIn pour ce canal.",
            priceAppOut: "Prix spécial à emporter sur la caisse. Remplace priceOut pour ce canal.",
            priceWebIn: "Prix spécial sur place sur la commande en ligne. Remplace priceIn pour ce canal.",
            priceWebOut: "Prix spécial à emporter sur la commande en ligne. Remplace priceOut pour ce canal.",
            priceKioskIn: "Prix spécial sur place sur la borne. Remplace priceIn pour ce canal.",
            priceKioskOut: "Prix spécial à emporter sur la borne. Remplace priceOut pour ce canal.",
        },
    },
    examples: {
        dishes: "Plats",
        pizzas: "Pizzas",
        extras: "Suppléments",
        drinks: "Boissons",
        pizzaName: "Margherita",
        pizzaDescription: "Tomate, mozzarella, basilic",
        toppingName: "Mozzarella supplémentaire",
        drinkName: "Eau plate 50 cl",
        listName: "Suppléments pizza",
        listDescription: "Choisissez jusqu'à 3 suppléments",
    },
};

const quickMenuStrings = {
    argumentTextPlaceholder: "Votre recherche...",
    argumentIdPlaceholder: "Numéro...",
    askProduct: "Commencez à taper le nom ou le numéro d'un produit",
    askGroup: "Commencez à taper le nom ou le numéro d'un groupe",
    askClient: "Commencez à taper le nom ou le numéro d'un client",
    askStock: "Commencez à taper le nom ou le numéro d'un produit",
    askOrg: "Commencez à taper le nom ou le numéro d'une organisation",
    askAccount: "Entrez le numéro d'un compte",
    askShift: "Entrez le numéro d'un service",
    askShiftStat: "Entrez le numéro d'un service",
    commandProduct: "Aller vers un produit",
    commandGroup: "Catalogue — Aller vers un groupe",
    commandClient: "Aller vers un client",
    commandStock: "Voir le stock d'un produit",
    commandOrg: "Changer d'organisation",
    commandAccount: "Ouvrir un compte",
    commandShift: "Ouvrir un service",
    commandShiftStat: "Statistiques d'un service",
    kindCommand: "Commande",
    argumentPlaceholder: "Nom ou numéro...",
    hintComplete: "compléter",
    switchOrg: "Basculer vers",
    jump: "Ouvrir directement",
    kindJump: "Raccourci",
    openAccount: "Ouvrir le compte",
    openShift: "Ouvrir le service",
    openShiftStat: "Statistiques du service",
    openProduct: "Ouvrir le produit",
    openGroup: "Ouvrir le groupe",
    openClient: "Ouvrir le client",
    openStock: "Stock du produit",
    clearRecent: "Effacer",
    settingsFields: "Réglages",
    hintTabSettings: "Tab pour modifier",
    hintSave: "enregistrer",
    openInSettings: "Ouvrir dans les réglages",
    results: "Résultats",
    suggestions: "Suggestions",
    placeholder: "Rechercher une page ou une action...",
    goTo: "Aller vers",
    actions: "Actions rapides",
    recent: "Récent",
    kindPage: "Page",
    kindAction: "Action",
    hintMove: "naviguer",
    hintOpen: "ouvrir",
    hintToggle: "menu rapide"
}

export default {
    quickMenu: quickMenuStrings,
    generic: genericStrings,
    navBar: navBarStrings,
    toast: toastStrings,
    dashboard: dashboardStrings,
    productGroupsDashboard: productGroupsDashboardStrings,
    playlist: playlistStrings,
    loginPage: loginPageStrings,
    userPage: userPageStrings,
    superUserPage: superUserPageStrings,
    productGroupPage: productGroupPageStrings,
    productPage: productPageStrings,
    productOptionsPage: productOptionsPageStrings,
    catalogPage: catalogPageStrings,
    catalogWorkbook: catalogWorkbookStrings,
    importPage: importPageStrings,
    stockPage: stockPageStrings,
    tablePage: tableStrings,
    paymentsPage: paymentsStrings,
    orderedProductsPage: orderedProductsString,
    accountHistoryPage: accountHistory,
    openAccountsPage: openAccounts,
    shiftDetailPage: shiftDetail,
    shiftStatPage: shiftStat,
    clientStrings: clientStrings,
    shiftPage: shift,
    integrationStrings: integrationStrings,
    pickupPageStrings:pickupPageStrings,
    deliveryAreaPage: deliveryAreaPageStrings,
    printerStrings: printerStrings,
    aiDebugger: aiDebuggerStrings,
    settingsPage: settingsPageStrings,
    deviceStrings: deviceStrings,
    invoicePage: invoicePageStrings,
    kitchenPageStrings: kitchenPageStrings,
    imagePageStrings: imagePageStrings,
    iconsPageStrings: iconsPageStrings,
    promoPageStrings: promoPageStrings,
    voucherPageStrings: voucherPageStrings,
    websitePageStrings : websitePageStrings,
    topBar: topBarStrings,
    preferencesPage: preferencesPageStrings,
    createOrgPage: createOrgPageStrings
};
